import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import StartAssesmnetPage from './FutureTheme/Assesment/StartAssesmnetPage';
import AssessmentFutureTheme from './FutureTheme/Assesment/AssesmentFutureTheme';
import CertificationHub from './FutureTheme/Assesment/CertificationHub';
import { useColor } from 'components/ui/ColorContext';
import LoadingOverlay from './LoadingOverlay';
import {  Button, Text } from '@chakra-ui/react';
import React, {
  startTransition,
  useEffect,
  useRef,
  useCallback,
  useState,
  createContext,
  useContext,
  lazy,
} from 'react';
import {
  activityUpdate,
  activityCreate,
  createGamePlayHistory,
  activitygetlastblock,
} from 'utils/gameApplication/gameActivityService';

import {
  getGameLanguages,
  getContentRelatedLanguage,
  getTimespent,
  AllQestSingleScore,
  questScore,
  getchapterQuestScore,
  blockScore,
} from 'utils/game/gameService';
import LearnerMainFile from './FutureTheme/LearnerReport/LearnerMainFile';

import SkillSet from './FutureTheme/Overview';
import TopMenuBarFutureTheme from './FutureTheme/TopMenuBarFutureTheme';
import ReflectionFutureTheme from './FutureTheme/ReflectionFutureTheme';
import ThankyouFutureTheme from './FutureTheme/ThankyouFutureTheme';
import QuestCompletionFutureTheme from './FutureTheme/QuestCompletionFutureTheme';

import TakeawayFutureTheme from './FutureTheme/TakeawayFutureTheme';
import FinalCertificate from './FutureTheme/Assesment/FinalCertificate';

import WelcomeFutureTheme from './FutureTheme/WelcomeFutureTheme';
import CharacterSelectionFutureTheme from './FutureTheme/ChararcterSelectionFutureTheme';
import OverallQuestCompletionFutureTheme from './FutureTheme/OverallQuestCompletionFutureTheme';
import ReplayScoreFutureTheme from './FutureTheme/ReplayScoreFutureTheme';
import GameIntroScreenFutureTheme from './FutureTheme/GameIntroScreenFutureTheme';
import LeaderBoardFutureTheme from './FutureTheme/LeaderBoardFutureTheme';
import { updateLearnerDetails } from 'utils/gameApplication/gamePlayService';
import { ScoreContext } from './GamePreview';
import { useParams } from 'react-router-dom';
import { ProfileType } from './GamePreview';
import ReplayScore from './playcards/ReplayScore';
import Story from './playcards/Story';
import Welcome from './playcards/Welcome';
import ThankYou from './playcards/Thankyou';
import Reflection from './playcards/Reflection';
import Takeway from './playcards/Takeaway';
import Completion from './playcards/Completion';
import ReplayGame from './playcards/ReplayGame';
import PlayInfo from './playcards/playinfo';
import LeaderBoard from './playcards/Leaderboard';
import Characterspage from './playcards/CharacterSelection';
import ChapterPage from './playcards/Chapters';
import FeedBackScreen from './playcards/FeedBackScreen';
import CompletionFeedBackScreenFutureTheme from './FutureTheme/CompletionFeedBackScreenFutureTheme';
import TopMenuBar from './playcards/TopMenuBar';
import GameIntroScreen from './playcards/GameIntroScreen';

import ModelPlayer from './playcards/Model';
import { ScenarioChange } from 'utils/gameApplication/gamePlayService';
import { gamereport } from 'utils/game/gameService';
import { generateReportHTML } from './FutureTheme/LearnerReport/generateReportHTML';
import { sampleLearnerData } from './FutureTheme/LearnerReport/Data/reportData';
import { checklistData } from './FutureTheme/LearnerReport/Data/checklistData';
import { takeawaysData } from './FutureTheme/LearnerReport/Data/takeawaysData';
import { API_SERVER } from 'config/constant';
import { incrementScenarioReplayCount, logActivity, updateScreenActivity } from './common';
import { useNavigate } from 'react-router-dom'; 


import {
  checkIsMandatoryReplayPromptRequired,
  isOptionalReplayAllow,
  getPlayerFinalScore,
} from './HelperFunctions';
import MentorCharacterspage from './playcards/MentorCharacterSelection';
import MentorCharacterSelectionFutureTheme from './FutureTheme/MentorChararcterSelectionFutureTheme';
const BackgroundGLB = lazy(() => import('./playcards/BackgroundFeedback'));
const Emporium = lazy(() => import('./playcards/Emporium'));
const FurturisticCity = lazy(() => import('./playcards/furturisticCity'));
const FuturistiLab = lazy(() => import('./playcards/futuristiLab'));
const FutureThemeLab = lazy(() => import('./playcards/FutureThemeLab'));
const FutureThemeLab1 = lazy(() => import('./playcards/FutureThemeLab1'));
const FutureThemeWorkshop = lazy(
  () => import('./playcards/FutureThemeWorkshop'),
);
const FutureThemeWorkShop1 = lazy(
  () => import('./playcards/FutureThemeWorkShop1'),
);
const FuturisticOffice = lazy(() => import('./playcards/futuristicOffice'));
const Castle = lazy(() => import('./playcards/castle'));
const Office = lazy(() => import('./playcards/office'));
const Underground = lazy(() => import('./playcards/underground'));
const RealisticOffice = lazy(() => import('./playcards/RealisticOffice'));
const RealFactory = lazy(() => import('./playcards/RealFactory'));
const RealWorkplace = lazy(() => import('./playcards/RealWorkplace'));
const MagicalGarden = lazy(() => import('./playcards/MagicalGarden'));
const QuestHubLab = lazy(() => import('./playcards/ThreeQuestHubScene'));
type ScoreItem = {
  seqId?: string;
  score?: number;
  choosedoption?: string;
  quest?: number;
  scoreEarnedDate?: string;
  scenarioId?: number;
};
interface ShowPreviewProps {
  setGameInfo?: any;
  gameInfo: any;
  gameIdingamepreview:any;
  preloadedAssets: any;
  InitialScreenId: number;
  setIsAuthFailed: any;
  isAuthFailed: any;
  isLoading: any;
  glbName: any;
  timer: any;
  setTimer: any;
  seconds: any;
  setSeconds: any;
  selectedBackground: any;
  assignedData: any;
  gamethemecolor: any;
  NonPlayerNameLanguageId: any;
  setNonPlayerNameLanguageId: any;
  filteredCharacterGLBs: any;
  scenarioNpc: any;
  audioCache: any;
  audioCacheRef: any;
  audioReady: boolean;
  setAudioReady: any;
}
interface PrevLogData {
  previewLogId: string;
  playerId: string;
  playerType: string;
  previewGameId: string;
  nevigatedSeq: any[];
  screenIdSeq: any[];
  lastActiveBlockSeq: any;
  selectedOptions: any;
  previewProfile: any;
  lastModifiedBlockSeq: string;
  lastBlockModifiedDate: string;
  updatedAt: string;
  playerInputs: any;
  audioVolumeValue: any | null;
  previewScore: ProfileType;
  questState: any;
}

interface ProfileDataType {
  name?: string;
  mentorname?: string;
  gender?: string;
  selectedplayer?: string;
  language?: any;
  score?: any;
  allTimeScore?: any;
  content?: any;
  audioUrls?: any;
  textId?: any;
  fieldName?: any;
  [x: string]: any;
}
export const ProfileContext = createContext<ProfileDataType>({
  name: '',
  mentorname: '',
  gender: '',
  selectedplayer: '',
  language: '',
  score: 350,
  allTimeScore: 950,
});
type QuestWiseMaxTotal = { [key: number]: number };
type Block = {
  blockId: number;
  blockScenario?: string;
};
const EntirePreview: React.FC<ShowPreviewProps> = ({
  gameInfo,
  gameIdingamepreview,
  setGameInfo,
  preloadedAssets,
  InitialScreenId,
  setIsAuthFailed,
  isAuthFailed,
  isLoading,
  glbName,
  timer,
  setTimer,
  seconds,
  setSeconds,
  selectedBackground,
  assignedData,
  gamethemecolor,
  NonPlayerNameLanguageId,
  setNonPlayerNameLanguageId,
  filteredCharacterGLBs,
  scenarioNpc,
  audioReady,
  setAudioReady,
  audioCacheRef,
  audioCache,
}) => {

  const [nextcharactervoice, setNextcharactervoice] = useState(false);
  const [OptionalReplayTracked, setOptionalReplayTracked] =
    useState<boolean>(false);
  const [hubDialogAudio, setHubDialogAudio] = useState('');
  const [walkanimation, setWalkanimation] = useState<boolean>(false);
  const [nextcharacter, setNextcharacter] = useState<string>('');
const navigate = useNavigate();

const { primaryColor } = useColor();



const handleAssignmentErrorClose = () => {
  setIsAssignmentError(false);
  navigate("/game/gamePlay");
};
  const [iscompletedVideoMap, setIsCompletedVideoMap] = useState<
    Record<string, boolean>
  >({
    quest1: false,
    quest2: false,
    quest3: false,
    quest4: false,
    quest5: false,
  });

  const completedVideoRef = useRef<Record<string, boolean>>({});
  const actionRef = useRef(null);
  const user: any = JSON.parse(localStorage.getItem('user'));
  const { id } = useParams();
  const { learner_game_play_id } = useParams();
  const Gameid = id ? id : null;
  const audioRef = React.useRef(null);
  const [data, setData] = useState(null);

  const [type, setType] = useState<string>('');

  const [interactionfeedback, setinteractionfeedback] = useState<string>('');
  const [resMsg, setResMsg] = useState<string>('');
  const [feed, setFeed] = useState<string>('');
  const [navi, setNavi] = useState<string>('');
  const [options, setOptions] = useState(null);
  const [optionNavigation, setOptionNavigation] = useState(null);
  const [getSelectedOptions, SetgetSelectedOptions] = useState<any>({});
  const [badgename, setBadgename] = useState<string | null>(null);
  const [FeedbackcurrentPosition, setFeedbackCurrentPosition] = useState(0);
  const [interactionBlockArray, setInterActionBlockArray] = useState<any | []>(
    [],
  );

  const [WeHaveChooseCompleted, setWeHaveChooseCompleted] = useState(false);
  const [isSwipeMiniGameCompleted, setIsSwipeMiniGameCompleted] =
    useState(false);
  const [isDragForNowCompleted, setIsDragForNowCompleted] = useState(false);

  const [FeedbackremainingSentences, setFeedbackRemainingSentences] = useState<
    any[]
  >([]);
  const [InterActionScore, setInterActionScore] = useState<any[]>([]);
  const [scenarioNpcs, setScenarioNpcs] = useState({});
  const [scenarioChange, setScenarioChange] = useState(false);

  const [FeedbackNavigatenext, setFeedbackNavigateNext] = useState<any>(false);
  const [isScreenshot, setisScreenshot] = useState<any>(false);
  const [FeedBackoptionData, setFeedBackoptionData] = useState(null);
  const [FeedBackselectedoptionData, setFeedBackSelectedoptionData] =
    useState(null);
  const [isOptionalReplay, setisOptionalReplay] = useState<any>(false);
  const [isReplay, setisReplay] = useState<any>(false);
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [audio, setAudio] = useState<string>('');
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [demoBlocks, setDemoBlocks] = useState(null);
  const [currentQuestNo, setCurrentQuestNo] = useState(1);
  const [homeLeaderBoard, setHomeLeaderBoard] = useState(null);
  const { profile, setProfile,learnerActivityrec,setlearnerActivityrec,deviceInfo,setIsAssignmentError, isAssignmentError ,loadingProgress, setLoadingProgress} = useContext(ScoreContext);
  const [replayIsOpen, setReplayIsOpen] = useState(null);
  const scoreComp =
    profile?.score !== undefined
      ? profile?.score?.length > 0
        ? profile?.score[0]?.score
        : 0
      : 0;
  const [OptionSelectId, setOptionSelectId] = useState(null);

  const [showFloatingHub, setShowFloatingHub] = useState(false);
  const [playerTodayScore, setPlayerTodayScore] = useState<any>(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [backgroundtheme, setBackgroundTheme] = useState(gameInfo?.assets);

  const [badgethpath, setBadgethpath] = useState<number | null>(null);
 

  const [currentReplayInfo, setCurrentReplayInfo] = useState<{
    scenarioName: any;
    replayType: string;
    questNo: number;
  } | null>(assignedData?.currentReplayInfo ?? null );
  const [profileData, setProfileData] = useState<ProfileDataType>({
    name: '',
    gender: '',
    selectedplayer: '',
    language: '',
    score: '',
    allTimeScore: 250,
    content: '',
    audioUrls: '',
    textId: '',
    fieldName: '',
    Audiogetlanguage: [],
  });
  const [getIntractionscore, setGetIntractionscore] = useState(0);
  const [lastInteractionScore, setLastInteractionScore] = useState(0);
  const [overallqueststate, setoverallqueststate] = useState(false);
  const scoreRef = useRef(0);
  const [replayState, setReplayState] = useState<string>(null);
  const [firstLoading, setFirstLoading] = useState<boolean>(true);
  const [profilescore, Setprofilescore] = useState(null);
  const [voiceIds, setVoiceIds] = useState<any>();
  const [feedbackList, setFeedbackList] = useState(assignedData?.feedbackList ? assignedData?.feedbackList : []);
  const [navTrack, setNavTrack] = useState([]);
  const [currentScreenId, setCurrentScreenId] =
    useState<number>(InitialScreenId);
  const [modalLoaded, setModalLoaded] = useState<any>(false);
  const hexToRgb = (hex: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 255, 187';
  const r = Number.parseInt(result[1], 16);
  const g = Number.parseInt(result[2], 16);
  const b = Number.parseInt(result[3], 16);
  return `${r}, ${g}, ${b}`;
};

  const [hasMulitLanguages, setHasMulitLanguages] = useState<boolean>(false);
  const [gameLanguages, setGameLanguages] = useState([]);
  const [RepeatSelectOption, setRepeatSelectOption] = useState<boolean>(false);
  const [RepeatPrevOption, setRepeatPrevOption] = useState<any>([]);

  const [isInitialLoadScreenWelcome, setIsInitialLoadScreenWelcome] =
    useState<boolean>(false);
  const [questState, setQuestState] = useState<any>(assignedData?.questState ? assignedData?.questState : {});
  const [AssignId, setAssignId] = useState<any>(0);
  const [Activitydata, setActivitydata] = useState<any>([]);
  const [prevBlock, setprevBlock] = useState<any>([]);
  const EnumType = {
    BGM: 'bgm',
    VOICE: 'voice',
  };
  const backgroundBgmRef = useRef<HTMLAudioElement>(null);
  const voiceRef = useRef<HTMLAudioElement>(null);
  const timeRef = useRef<number | null>(null);

  const [isQuestCalled, setIsQuestCalled] = useState(false);

  const [totalTimeSpended, setTotalTimeSpended] = useState('0:00');
  const [isAudioPaused, setIsAudioPaused] = useState(false);
  const [isAnimationPaused, setIsAnimationPaused] = useState(false);
  const LearnerDefaultData = {
      name: gameInfo?.learnerDetails?.lenUserName ?? '',
      age: gameInfo?.learnerDetails?.lenAge ?? '',
      companyId: gameInfo?.learnerDetails?.lenCompanyId ?? '',
      CountryId: gameInfo?.learnerDetails?.lenCountryId ?? '',
      gender: gameInfo?.learnerDetails?.lenGender ?? '',
      Department: gameInfo?.learnerDetails?.lenDepartment ?? '',
      language: 1,
      education: gameInfo?.learnerDetails?.lenEducation ?? '',
      mailId: gameInfo?.learnerDetails?.lenMail ?? '',
      score: '',
      nickName: gameInfo?.learnerDetails?.lenNickName ?? '',
      region: gameInfo?.learnerDetails?.lenRegion ?? '',
      allTimeScore: '',
    };
  const default_profile_data :any= {
      completedLevels: ['1'],
      currentQuest: 1,
      compQuest: ['1'],
      score: [],
      completeBadgseShow: [],
    }
  const [learnerPlayList, setLearnerPlayingDetails] = useState<any>({
    playerId: user?.data?.id,
    playerType: user?.data?.role,
    GameId: parseInt(learner_game_play_id),
    screenIdSeq: assignedData?.screenIdSeq ?? [],
    LearnerProfile: assignedData?.LearnerProfile ?? LearnerDefaultData,
    CurrentBlock: assignedData?.CurrentBlock ? assignedData?.CurrentBlock : '',
    mentor_gender: assignedData?.mentor_gender
      ? assignedData?.mentor_gender
      : '',
    selectedmentor_charcter: assignedData?.selectedmentor_charcter
      ? assignedData?.selectedmentor_charcter
      : '',
    player_gender: assignedData?.player_gender
      ? assignedData?.player_gender
      : '',
    selectedplayer_charcter: assignedData?.selectedplayer_charcter
      ? assignedData?.selectedplayer_charcter
      : '',
    playerInputs: assignedData?.playerInputs ? assignedData?.playerInputs : {},
    audioVolumeValue: { bgmVolume: 0.5, voiceVolume: 0.5 },
    PlayerScore_Level:assignedData?.PlayerScore_Level ? assignedData?.PlayerScore_Level : default_profile_data,
    firstTryScore: assignedData?.firstTryScore ? assignedData?.firstTryScore : [],
    Assessment:assignedData?.Assessment ? assignedData?.Assessment : [],
    totalTimeSpent: totalTimeSpended ? totalTimeSpended : 0,
    questWisePlayerScore: assignedData?.questWisePlayerScore ? assignedData?.questWisePlayerScore : 0,
    progress: assignedData?.progress ? assignedData?.progress : 0,
    feedbackList: assignedData?.feedbackList ? assignedData?.feedbackList : [],
    Prevquestseq: assignedData?.Prevquestseq ? assignedData?.Prevquestseq : [],
    questState: assignedData?.questState ? assignedData?.questState : {},
    preAssessment: assignedData?.preAssessment ? assignedData?.preAssessment : [],
    timeAlready: totalTimeSpended ? totalTimeSpended : 0,
    characterGender: assignedData?.characterGender ? assignedData?.characterGender : '',
    scenarioAttempts: assignedData?.scenarioAttempts ? assignedData?.scenarioAttempts : [],
    questwiseprogress:assignedData?.questwiseprogress ? assignedData?.questwiseprogress : [],
    currentReplayInfo:assignedData?.currentReplayInfo
  });
console.log(assignedData,'assignedData1212')
  const progressKey = `gameProgress_${learner_game_play_id}_${user?.data?.id}`;
  const [gameProgressData, setGameProgressData] = useState<any>({
    [progressKey]: assignedData?.gameProgressData?.[progressKey] || null,
    profileScore: assignedData?.gameProgressData?.profileScore || null,
    profileReplayScore: assignedData?.gameProgressData?.profileReplayScore || null,
    scenarioScores_backup: assignedData?.gameProgressData?.scenarioScores_backup || {},
    scenarioScores: assignedData?.gameProgressData?.scenarioScores || {},
  });

  const [audioObj, setAudioObj] = useState<{
    url: string;
    type: string;
    Voicevolume: any;
    BGMvolume: any;
    loop: boolean;
    autoplay: boolean;
    key: any;
  }>({
    url: '',
    type: EnumType.BGM,
    Voicevolume: learnerPlayList?.audioVolumeValue?.voiceVolume ?? 0.5,
    BGMvolume: learnerPlayList?.audioVolumeValue?.bgmVolume ?? 0.5,
    loop: true,
    autoplay: true,
    key: '',
  });

  const [getscore, setGetScore] = useState(0);

  const getAudioUrl = (audio: any): string => {
    if (!audio) return '';
    if (typeof audio === 'string') return audio.trim();
    if (typeof audio === 'object' && audio.url) return audio.url.trim();
    return '';
  };

  useEffect(() => {
    if (!profile?.score) return;
    if (isReplay) return; // ❌ Skip update during replay

    const newScore = profile.score;

  
    const getstoredData = gameProgressData?.profileScore || {"score":[]};
    const existingScores = getstoredData.score || [];

    const scoreMap = new Map();

    existingScores.forEach((item: any) => {
      if (item.seqId) {
        scoreMap.set(item.seqId, item);
      }
    });

    newScore.forEach((item: any) => {
      if (!item.seqId) return;

      if (!scoreMap.has(item.seqId)) {
        scoreMap.set(item.seqId, item); // ✅ only first time
      }
    });

    const mergedScores = Array.from(scoreMap.values());
    setGameProgressData((prev: any) => ({
      ...prev,
      profileScore: { score: mergedScores },
    }))
   
  }, [profile?.score]);

  const handleScenarioCompletionSync = async () => {
  if (type !== 'ScenarioCompletion') return;
  if (!profile?.score && !profile?.replayScore) return;

  /* =====================================================
     SCORE SYNC
  ===================================================== */

  const dbScores: ScoreItem[] = profile.score || [];


  const getstoredData = gameProgressData?.profileScore;
  const lsScores: ScoreItem[] = getstoredData.score || [];


  const filteredDb = dbScores.filter((item) => item.seqId);
  const filteredLs = lsScores.filter((item) => item.seqId);

  const dbTotal = filteredDb.reduce(
    (sum, item) => sum + (item.score || 0),
    0,
  );

  const lsTotal = filteredLs.reduce(
    (sum, item) => sum + (item.score || 0),
    0,
  );

  const lsMap = new Map(filteredLs.map((item) => [item.seqId, item]));
  const dbMap = new Map(filteredDb.map((item) => [item.seqId, item]));

  let finalUpdatedScore = dbScores;

  // CASE 1: DB > LS → Replace Local
  if (dbTotal > lsTotal) {
    setGameProgressData((prev: any) => ({
      ...prev,
      profileScore: { score: dbScores },
    }))
   
  }

  // CASE 2: LS > DB → Replace DB using LS
  if (lsTotal > dbTotal) {
    finalUpdatedScore = dbScores.map((dbItem) => {
      if (!dbItem.seqId) return dbItem;

      const lsItem = lsMap.get(dbItem.seqId);

      if (!lsItem) return dbItem;

      return {
        ...dbItem,
        score: lsItem.score || 0,
      };
    });
  }

  /* =====================================================
     REPLAY SCORE SYNC
  ===================================================== */

  const dbReplayScores: ScoreItem[] = profile.replayScore || [];

   const getstoredreplayscoreData = gameProgressData?.profileReplayScore || {"replayScore":[]};

  const lsReplayScores: ScoreItem[] =
    getstoredreplayscoreData.replayScore || [];

  const filteredReplayDb = dbReplayScores.filter(
    (item) => item.scenarioId,
  );

  const filteredReplayLs = lsReplayScores.filter(
    (item) => item.scenarioId,
  );

  const dbReplayTotal = filteredReplayDb.reduce(
    (sum, item) => sum + (item.score || 0),
    0,
  );

  const lsReplayTotal = filteredReplayLs.reduce(
    (sum, item) => sum + (item.score || 0),
    0,
  );

  const lsReplayMap = new Map(
    filteredReplayLs.map((item) => [
      `${item.quest}_${item.scenarioId}`,
      item,
    ]),
  );

  let finalUpdatedReplayScore = dbReplayScores;

  // CASE 1: DB > LS → Replace Local
  if (dbReplayTotal > lsReplayTotal) {
    setGameProgressData((prev: any) => ({
      ...prev,
      profileReplayScore: { replayScore: dbReplayScores },
    }))
  
  }

  // CASE 2: LS > DB → Replace DB using LS
  if (lsReplayTotal > dbReplayTotal) {
    finalUpdatedReplayScore = dbReplayScores.map((dbItem) => {
      const key = `${dbItem.quest}_${dbItem.scenarioId}`;
      const lsItem = lsReplayMap.get(key);

      if (!lsItem) return dbItem;

      return {
        ...dbItem,
        score: lsItem.score || 0,
      };
    });
  }

  /* =====================================================
     FINAL PROFILE UPDATE
  ===================================================== */

  setProfile((prev: any) => ({
    ...prev,
    score: finalUpdatedScore,
    replayScore: finalUpdatedReplayScore,
  }));

 
};
useEffect(() => {
  if (currentScreenId === 6) {
   
    setGameProgressData((prev: any) => ({
      ...prev,
      profileReplayScore: null,
    }))
    setProfile((prev: any) => ({
      ...prev,
      replayScore: [],
    }));
  }
   let screenName = "";
 
    switch (currentScreenId) {
      case 1:
        screenName= "Welcome Screen"
        break;
      case 2:
        screenName= "Story"
        break;
      case 3:
        screenName= "Reflection"
        break;
      case 4:
        screenName= "Leaderboard"
        break;
      case 5:
        screenName= "Thankyou"
        break;
      case 6:
        screenName= "Completion"
        break;
      case 7:
        screenName= "Takeway"
        break;
      case 10:
        screenName= "Game Intro"
        break;
      case 12:
        screenName= "Character Selection"
        break;
      case 20:
        screenName= "Mentor Selection"
        break;
      case 13:
        screenName= "Chapterpage"
        break;
      case 14:
        screenName= "Feedback"
        break;
      case 16:
        screenName= "Start Assesment"
        break;
      case 17:
        screenName= "Assessment Future"
        break;
      case 18:
        screenName= "Certification Hub"
        break;
      case 19:
        screenName= "Learnermainfile"
        break;
      case 21:
        screenName= "Overall Quest Completion"
        break;
      case 22:
        screenName= "Final Certificate"
        break;
      default:
        break;
    }
    setlearnerActivityrec((prev:any) =>
      updateScreenActivity(prev, currentScreenId, screenName,deviceInfo)
    );
}, [currentScreenId]);
useEffect(() => {
  handleScenarioCompletionSync();
}, [type]);
  
  useEffect(() => {
    handleScenarioCompletionSync();
  }, [type]);

  useEffect(() => {
    if (!hubDialogAudio) return;

    if (voiceRef.current) {
      voiceRef.current.pause();
      voiceRef.current.currentTime = 0;
    }

    setAudioObj((prev) => ({
      ...prev,
      url: getAudioUrl(hubDialogAudio),
      type: EnumType.VOICE,
      autoplay: true,
      loop: false,
    }));
  }, [hubDialogAudio]);


  const forceStopAllAudio = useCallback(async () => {
    // Stop all audio elements
    const stopPromises = [];

    // Stop BGM
    if (backgroundBgmRef.current) {
      if (!backgroundBgmRef.current.paused) {
        backgroundBgmRef.current.pause();
        backgroundBgmRef.current.currentTime = 0;
        backgroundBgmRef.current.src = '';
        stopPromises.push(
          new Promise((resolve) => {
            backgroundBgmRef.current?.load();
            resolve(true);
          }),
        );
      }
    }

    // Stop Voice
    if (voiceRef.current) {
      if (!voiceRef.current.paused) {
        voiceRef.current.pause();
        voiceRef.current.currentTime = 0;
        voiceRef.current.src = '';
        stopPromises.push(
          new Promise((resolve) => {
            voiceRef.current?.load();
            resolve(true);
          }),
        );
      }
    }

    // Stop any other audio elements
    const allAudioElements = document.querySelectorAll('audio');
    allAudioElements.forEach((audio) => {
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    });

    // Update state
    setAudioObj((prev) => ({
      ...prev,
      url: '',
      autoplay: false,
    }));

    // Wait for all stops to complete
    await Promise.all(stopPromises);
    await new Promise((resolve) => setTimeout(resolve, 30)); // Small delay

    return true;
  }, []);

  const [isLeaderboardEnabled, setIsLeaderboardEnabled] = useState(false);
  const [currentBlock, setCurrentBlock] = useState('');

  const [NonPlayerNameLanguage, setNonPlayerNameLanguage] = useState(
    gameInfo?.gameData?.gameNonPlayerName,
  );


  const [PlayerNameLanguage, setPlayerNameLanguage] = useState(
    profileData?.selectedplayer,
  );
  const [mentorNameLanguage, setMentorNameLanguage] = useState(
    profileData?.mentorselectedplayer,
  );

  const [questWisePlayerScore, setQuestWisePlayerScore] = useState(null);
  const [questWiseMaxScore, setQuestWiseMaxScore] = useState<any>({});
  const [questTotalScore, setQuestTotalScore] = useState<any>({});
  const [showScenarioTransition, setShowScenarioTransition] = useState();
   const getQuestWiseProgress = (
    assignedQuestProgress: any[],
    gameQuest: any[]
  ) => {
    
    // New learner → create default progress
    if (!assignedQuestProgress || assignedQuestProgress.length === 0) {
      return (gameQuest ?? []).map((item: any) => ({
        quest: item.gameQuestNo,
        progress: 0,
        percentage:0,
      }));
    }

    // Existing learner → preserve existing progress
    return (gameQuest ?? []).map((item: any) => {
      const existingQuest = assignedQuestProgress.find(
        (questItem: any) => questItem.quest === item.gameQuestNo
      );

      // Existing quest → keep its progress
      if (existingQuest) {
        return {
          quest: item.gameQuestNo,
          progress: existingQuest.progress ?? 0,
          percentage:existingQuest.percentage ?? 0,
        };
      }

      // New quest → add with 0 progress
      return {
        quest: item.gameQuestNo,
        progress: 0,
      };
    });
  };
  useEffect(() => {
    if(gameInfo?.gameQuest){

      
       
      setLearnerPlayingDetails((prev: any) => ({
           ...prev,
           questwiseprogress: getQuestWiseProgress(
             assignedData?.questwiseprogress,
             gameInfo?.gameQuest
           ),
      }));
    }
    if (gameInfo?.questOptions?.[0]) {
      setCurrentBlock(gameInfo.questOptions[0].qpNavigateShow);
    }
  }, [gameInfo]);

  const [allQuestScores, setAllQuestScore] = useState(null);

  const fetchchapterQuestScore = async () => {
    const data = {
      gameId: gameInfo.gameData.gameId,
      learnerid: learnerPlayList.playerId,
    };

    try {
      const result = await getchapterQuestScore(JSON.stringify(data));
      if (result.status === 'Success') {
        setQuestWiseMaxScore(result?.questWiseMaxScore || 0);
        setQuestTotalScore(result?.questTotalScore || 0);
         setoverallqueststate(result?.isAllQuestCompleted);
      }
    } catch (error) {
      console.error('Error fetching quest score', error);
    }
  };
  useEffect(() => {
    if (!OptionSelectId || !gameInfo?.questOptions) return;

    const selected = gameInfo.questOptions.find(
      (opt: any) => opt.qpOptionId === OptionSelectId,
    );

    setCurrentBlock(selected?.qpNavigateShow ?? '');
   
    setLearnerPlayingDetails((prev: any) => ({
      ...prev,
      CurrentBlock: selected?.qpNavigateShow ?? '',
      questwiseprogress:learnerPlayList?.questwiseprogress
    }));
  }, [OptionSelectId, gameInfo]);

  useEffect(() => {
    // const playerselected=learnerPlayList?.selectedplayer_charcter  ?  profileData?.selectedplayer;
    const playerselected =
      learnerPlayList?.selectedplayer_charcter ?? profileData?.selectedplayer;
    const mentorselected =
      learnerPlayList?.selectedmentor_charcter ??
      profileData?.mentorselectedplayer;
    setMentorNameLanguage(mentorselected);
    setPlayerNameLanguage(playerselected);
  }, [
    profileData?.selectedplayer,
    learnerPlayList?.selectedplayer_charcter,
    profileData?.mentorselectedplayer,
    learnerPlayList?.selectedmentor_charcter,
  ]);
  const [isDoorEntry, setIsDoorEntry] = useState(false);
  const [AudioOptions, SetAudioOptions] = useState({ qpOptionId: '' });

  const [score, setScore] = useState(null);

  const [upComingBlockChoosen, setUpComingBlockChoosen] = useState<any>(null);
  const [motionEffect, setMotionEffect] = useState<any>(false);
  const [isZoomComplete, setIsZoomComplete] = useState(false);
  const [scoreChapter, setScoreChapter] = useState<any>();
  const [showScenarioLeaderboard, setShowScenarioLeaderboard] = useState(false);

  const [GlbPlayindDetails, SetGlbPlayingDetails] = useState<{
    audioduration: any;
    characteraction: string;
    whospeak: string;
  }>({
    audioduration: 0,
    characteraction: '',
    whospeak: '',
  });

  const formatTime = (timeInSeconds: any) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const remainingSeconds = timeInSeconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };
  useEffect(() => {
    setCurrentScreenId(InitialScreenId);
    setlearnerActivityrec((prev:any) =>
      updateScreenActivity(prev, InitialScreenId, "Game Intro",deviceInfo)
    );
  }, [InitialScreenId]);

  useEffect(() => {
    const stopTimer = () => {
      if (timeRef.current !== null) {
        clearInterval(timeRef.current);
        timeRef.current = null;
      }
    };

    // Call the async cleanup function
    return () => {
      stopTimer();

      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        totalTimeSpent: formatTime(seconds),
      }));
    };
  }, []);


  useEffect(() => {
  if (!learnerActivityrec) return;

  logActivity(learnerActivityrec);
}, [learnerActivityrec]);
  const [ResultsShow, setResultShow] = useState<boolean>(false);
  useEffect(() => {


    setLearnerPlayingDetails((prev: any) => ({
      ...prev,
      totalTimeSpent: formatTime(seconds),
    }));

    if (currentScreenId === 6) {
      // localStorage.removeItem("evaluationShown");
      localStorage.removeItem('postAssestment');
      setResultShow(false);
    }
  }, [
    currentScreenId,
    profile,
    learnerPlayList?.Prevquestseq,
    learnerPlayList?.feedbackList,
  ]);







  useEffect(() => {
    const tabAllowed = [10, 8, 14, 0, 6, 4];
    setLearnerPlayingDetails((prev: any) => ({
      ...prev,
      PlayerScore_Level: profile,
      questState: questState,
      feedbackList: feedbackList,
      screenIdSeq: !tabAllowed.includes(currentScreenId)
        ? [currentScreenId]
        : prev.screenIdSeq,
    }));
  }, [profile, questState, currentScreenId, feedbackList]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' || document.hasFocus()) {
        if (
          voiceRef.current &&
          !voiceRef.current?.ended &&
          !voiceRef.current?.paused
        ) {
          voiceRef.current.pause();
        }
        if (
          backgroundBgmRef.current &&
          !backgroundBgmRef.current?.ended &&
          !backgroundBgmRef.current?.paused
        ) {
          backgroundBgmRef.current.pause();
        }
      } else if (document.visibilityState === 'visible') {
        if (currentScreenId) {
          if (
            voiceRef.current &&
            voiceRef.current?.paused &&
            !voiceRef.current?.ended &&
            currentScreenId === 2 &&
            voiceRef.current?.src !== '' &&
            voiceRef.current?.src !== null &&
            voiceRef.current?.src !== undefined
          ) {
            try {
              voiceRef.current.play().catch((error) => {});
            } catch (error) {
              console.error('Background BGM ref is not available.', error);
            }
          }
          if (
            backgroundBgmRef?.current &&
            backgroundBgmRef?.current?.paused &&
            ![2, 6, 4].includes(currentScreenId) &&
            backgroundBgmRef.current?.src !== '' &&
            backgroundBgmRef.current?.src !== null &&
            backgroundBgmRef.current?.src !== undefined
          ) {
            try {
              backgroundBgmRef.current?.play().catch((error) => {});
            } catch (error) {
              console.error('Background BGM ref is not available.', error);
            }
          }
        } else if (
          backgroundBgmRef.current &&
          !backgroundBgmRef.current?.ended &&
          !backgroundBgmRef.current?.paused &&
          currentScreenId !== 2
        ) {
          backgroundBgmRef.current.pause();
        }
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    if (
      [2, 10, 6, 4].includes(currentScreenId) &&
      backgroundBgmRef.current &&
      !backgroundBgmRef.current?.ended &&
      !backgroundBgmRef.current?.paused
    ) {
      backgroundBgmRef.current.pause();
    }
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [currentScreenId]);









// const UpdateLearnerData = async () => {
//   try {
//     const data = {
//       learnerPlayList: learnerPlayList,
//       gameProgressData: gameProgressData,
//     };

//     const dataString = JSON.stringify(data);

//     const UpdateLearnerDetails = await updateLearnerDetails(dataString);

//     if (
//       (UpdateLearnerDetails as any)?.error ===
//       "This game was Not assigned for this learner"
//     ) {
//       setIsAssignmentError(true); // ## Show popup by setting state to true
//       setLoadingProgress(100);
//       return; // ## Stop remaining code from executing
//     }

//     setLoadingProgress(100);

//     setAudioObj((prev) => ({
//       ...prev,
//       Voicevolume:
//         learnerPlayList?.audioVolumeValue?.voiceVolume ?? 0.5,
//       BGMvolume:
//         learnerPlayList?.audioVolumeValue?.bgmVolume ?? 0.5,
//     }));
//   } catch (error) {
//     console.error("Error in UpdateLearnerData:", error);
//   }
// };



//    useEffect(() => {
//     if (learner_game_play_id && ![10, 1].includes(currentScreenId)) {
  
      
//       UpdateLearnerData();
     
//     }
//   }, [
//     gameProgressData,
//     currentScreenId,
//     profile,
//     learnerPlayList?.questState,
//     learnerPlayList?.currentReplayInfo,
//     learnerPlayList?.Prevquestseq,
//     learnerPlayList?.feedbackList,
//     learnerPlayList?.questwiseprogress,
//     audioObj.Voicevolume,
//     audioObj.BGMvolume,
//     learnerPlayList?.scenarioAttempts,
//   ]);

const nextLockRef = useRef(false);
const [isNextLoading, setIsNextLoading] = useState(false);
const pendingMoveRef = useRef<Array<() => void>>([]); // held-back "move to next block" calls
const lastSaveOkRef = useRef(false);                  // did the last save succeed?
const saveFatalRef = useRef(false);                   // assignment error, so don't retry

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

const setTypeReal = setType;
const setDataReal = setData;
const setOptionsReal = setOptions;
const setCurrentScreenIdReal = setCurrentScreenId;
const setReplayIsOpenReal = setReplayIsOpen;
const setReplayStateReal = setReplayState;


const learnerUpdateInProgressRef = useRef(false);
const learnerUpdatePendingRef = useRef(false);

const latestLearnerDataRef = useRef({
  learnerPlayList,
  gameProgressData,
});

const lastSavedLearnerPlayListRef = useRef<any>(null);
const lastSavedGameProgressDataRef = useRef<any>(null);

latestLearnerDataRef.current = {
  learnerPlayList,
  gameProgressData,
};

const isEqual = (a: any, b: any) => {
  return JSON.stringify(a) === JSON.stringify(b);
};


const getChangedLearnerFields = (
  current: any,
  previous: any
) => {
  const changedFields: any = {};

  // These are ALWAYS required
  changedFields.playerId = current?.playerId;
  changedFields.GameId = current?.GameId;
  changedFields.LearnerProfile =
    current?.LearnerProfile;

  // First save: send all other fields
  if (!previous) {
    Object.keys(current || {}).forEach((key) => {
      if (
        key !== "playerId" &&
        key !== "GameId" &&
        key !== "LearnerProfile"
      ) {
        changedFields[key] = current[key];
      }
    });

    return changedFields;
  }

  // After first save: only send changed fields
  Object.keys(current || {}).forEach((key) => {
    if (
      key === "playerId" ||
      key === "GameId" ||
      key === "LearnerProfile"
    ) {
      return;
    }

    if (!isEqual(current[key], previous[key])) {
      changedFields[key] = current[key];
    }
  });

  return changedFields;
};


const UpdateLearnerData = async () => {

    lastSaveOkRef.current = false;          // <-- NEW (first line)
  saveFatalRef.current = false;    

  const {
    learnerPlayList: currentLearnerPlayList,
    gameProgressData: currentGameProgressData,
  } = latestLearnerDataRef.current;

  const previousLearnerPlayList =
    lastSavedLearnerPlayListRef.current;

  const changedLearnerPlayList =
    getChangedLearnerFields(
      currentLearnerPlayList,
      previousLearnerPlayList
    );

  // ---------------------------------------
  // Check gameProgressData
  // ---------------------------------------
  const gameProgressDataChanged =
    !lastSavedGameProgressDataRef.current ||
    !isEqual(
      currentGameProgressData,
      lastSavedGameProgressDataRef.current
    );


  // ---------------------------------------
  // Build request
  // ---------------------------------------
  const data: any = {
    learnerPlayList:
      changedLearnerPlayList,
  };


  if (gameProgressDataChanged) {
    data.gameProgressData =
      currentGameProgressData;
  }


  const dataString =
    JSON.stringify(data);


  console.log(
    "Update learner payload:",
    (dataString.length / 1024).toFixed(2),
    "KB"
  );


  // ---------------------------------------
  // API
  // ---------------------------------------
  const response =
    await updateLearnerDetails(
      dataString
    );


  if (
    (response as any)?.error ===
    "This game was Not assigned for this learner"
  ) {
     saveFatalRef.current = true;   
    setIsAssignmentError(true);
    setLoadingProgress(100);
    return;
  }


  // ---------------------------------------
  // Save successful snapshot
  // ---------------------------------------
  lastSavedLearnerPlayListRef.current =
    currentLearnerPlayList;

  lastSavedGameProgressDataRef.current =
    currentGameProgressData;


  setLoadingProgress(100);


  setAudioObj((prev) => ({
    ...prev,

    Voicevolume:
      currentLearnerPlayList
        ?.audioVolumeValue?.voiceVolume ?? 0.5,

    BGMvolume:
      currentLearnerPlayList
        ?.audioVolumeValue?.bgmVolume ?? 0.5,
  }));
   lastSaveOkRef.current = true;  
};


const UpdateLearnerDataSafe = async () => {
  if (
    learnerUpdateInProgressRef.current
  ) {
    learnerUpdatePendingRef.current = true;
    return;
  }

  learnerUpdateInProgressRef.current = true;

  try {
    do {
      learnerUpdatePendingRef.current = false;

      await UpdateLearnerData();

    } while (
      learnerUpdatePendingRef.current
    );

  } catch (error) {
    console.error(
      "Error in UpdateLearnerDataSafe:",
      error
    );

  } finally {
    learnerUpdateInProgressRef.current = false;
  }
};

// const learnerUpdateInProgressRef = useRef(false);
// const learnerUpdatePendingRef = useRef(false);

// const UpdateLearnerData = async () => {
//   try {
//     const data = {
//       learnerPlayList,
//       gameProgressData,
//     };

//     const dataString = JSON.stringify(data);

//     const UpdateLearnerDetails =
//       await updateLearnerDetails(dataString);

//     if (
//       (UpdateLearnerDetails as any)?.error ===
//       "This game was Not assigned for this learner"
//     ) {
//       setIsAssignmentError(true);
//       setLoadingProgress(100);
//       return;
//     }

//     setLoadingProgress(100);

//     setAudioObj((prev) => ({
//       ...prev,
//       Voicevolume:
//         learnerPlayList?.audioVolumeValue?.voiceVolume ?? 0.5,
//       BGMvolume:
//         learnerPlayList?.audioVolumeValue?.bgmVolume ?? 0.5,
//     }));
//   } catch (error) {
//     console.error("Error in UpdateLearnerData:", error);
//   }
// };

// const UpdateLearnerDataSafe = async () => {
//   // If a request is already running, remember that another update is needed
//   if (learnerUpdateInProgressRef.current) {
//     learnerUpdatePendingRef.current = true;
//     return;
//   }

//   learnerUpdateInProgressRef.current = true;

//   try {
//     await UpdateLearnerData();
//   } catch (error) {
//     console.error("UpdateLearnerDataSafe error:", error);
//   } finally {
//     learnerUpdateInProgressRef.current = false;

//     // If state changed while request was running,
//     // send one latest update after a short delay
//     if (learnerUpdatePendingRef.current) {
//       learnerUpdatePendingRef.current = false;

//       setTimeout(() => {
//         UpdateLearnerDataSafe();
//       }, 200);
//     }
//   }
// };

useEffect(() => {
  if (nextLockRef.current) return;
  if (
    learner_game_play_id &&
    ![10, 1].includes(currentScreenId)
  ) {
    UpdateLearnerDataSafe();
  }
}, [
  gameProgressData,
  currentScreenId,
  profile,
  learnerPlayList?.questState,
  learnerPlayList?.currentReplayInfo,
  learnerPlayList?.Prevquestseq,
  learnerPlayList?.feedbackList,
  learnerPlayList?.questwiseprogress,
  learnerPlayList?.scenarioAttempts,
]);

  useEffect(() => {
    setProfileData((prev: any) => ({ ...prev, score: scoreComp }));
  }, [scoreComp]);

  useEffect(() => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    const scores = profile?.score;
    const sums: any = {};
    scores?.forEach((score: any) => {
      const quest = score.quest;
      if (!sums[quest]) {
        sums[quest] = 0;
      }
      if (score.scoreEarnedDate === formattedDate) {
        sums[quest] += score.score;
      }
    });

    let getFinalscores = {};
    Object.entries(sums).forEach(([quest, score]) => {
      const IntQuest = parseInt(quest);
      const newQuest = { ...getFinalscores, [IntQuest]: score };
      getFinalscores = { ...newQuest };
    });
    const TodayTotalScore = Object.entries(getFinalscores).reduce(
      (tot: number, acc: any) => {
        tot += acc[1];
        return tot;
      },
      0,
    );
    setPlayerTodayScore(TodayTotalScore);
  }, [profile?.score]);

  useEffect(() => {
    if (profile?.language) {
      setProfileData((prev: any) => ({ ...prev, language: profile.language }));
    }
  }, [profile?.language]);
  useEffect(() => {
    const fetchGameContent = async () => {
      const languageId = learnerPlayList?.LearnerProfile?.language;
      if (learnerPlayList?.LearnerProfile?.language) {
        setProfileData((prev: any) => ({
          ...prev,
          language: learnerPlayList?.LearnerProfile?.language,
        }));
      }
      const gameContentResult = await getContentRelatedLanguage(
        gameInfo?.gameData.gameId,
        languageId,
      );
      setLoadingProgress(80);
      if (gameContentResult?.status === 'Success') {
        const data = gameContentResult.data;
        setProfileData((prev: any) => ({
          ...prev,
          Audiogetlanguage: data.map((x: any) => ({
            content: x.content,
            audioUrls: x.audioUrls,
            textId: x.textId,
            fieldName: x.fieldName,
          })),
        }));
      }
    };
    if (profileData.language !== '') {
      fetchGameContent();
    }
  }, [profileData?.language]);

  useEffect(() => {
    setDemoBlocks(gameInfo?.blocks);
    if (gameInfo?.gameQuest) {
      const initialPreAssessment: any = {};
      gameInfo.gameQuest.forEach((quest: any) => {
        initialPreAssessment[quest.gameQuestNo] = false;
      });
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        preAssessment: { ...initialPreAssessment, ...prev.preAssessment },
      }));
    }
    if (data === null && profile.currentQuest) {
      setType(gameInfo?.blocks[profile?.currentQuest]?.['1']?.blockChoosen);
      setData(gameInfo?.blocks[profile?.currentQuest]?.['1']);
      if (
        gameInfo?.blocks[profile?.currentQuest]?.['1']?.blockChoosen ===
        'Interaction'
      ) {
        const optionsFiltered = [];
        const primarySequence =
          gameInfo.blocks[profile.currentQuest]?.['1'].blockPrimarySequence;

        for (const option of gameInfo.questOptions) {
          if (profileData?.Audiogetlanguage.length > 0) {
            if (option?.qpSequence === primarySequence) {
              const profilesetlan = profileData?.Audiogetlanguage.find(
                (key: any) => key?.textId === option.qpOptionId,
              );

              if (profilesetlan) {
                const languagecont = {
                  ...option,
                  qpOptionText: profilesetlan.content,
                };
                optionsFiltered.push(languagecont);
              } else {
                optionsFiltered.push(option);
              }
            }
          } else {
            if (option?.qpSequence === primarySequence) {
              optionsFiltered.push(option);
            }
          }
        }
        if (gameInfo?.gameData?.gameShuffle === 'true') {
          for (let i = optionsFiltered.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [optionsFiltered[i], optionsFiltered[j]] = [
              optionsFiltered[j],
              optionsFiltered[i],
            ];
          }
        }
        setOptions(optionsFiltered);
      }
    }
  }, [profile?.currentQuest]);
  const calculatePlayerGrandTotal = async () => {
    const questScores: any = {};
    const scoreArray =
      questState[parseInt(profile?.currentQuest)] == 'Started'
        ? profile?.score
        : profile?.replayScore;
    if (scoreArray?.length > 0) {
      scoreArray.forEach((score: any) => {
        if (questScores[score.quest]) {
          questScores[score.quest] += score.score;
        } else {
          questScores[score.quest] = score.score;
        }
      });
      setProfile((prev: any) => ({
        ...prev,
        playerGrandTotal: {
          ...prev?.playerGrandTotal,
          questScores,
        },
      }));
    }
    return;
  };
  useEffect(() => {}, [profile?.playerGrandTotal]);
  useEffect(() => {
    const calculateQuestGrandTotal = async () => {
      let GrandMaximumscore: any = null;
      if (options) {
        let currentScores;
        const questStatus = questState[profile?.currentQuest];
        if (questStatus === 'completed') {
          if (profile?.score !== null) {
            currentScores = profile.score;
          } else {
            console.warn(
              '*****Invalid score or replayScore provided for completed quest.',
            );
            return;
          }
        } else if (questStatus === 'Started') {
          if (questStatus === 'Started') {
            currentScores =
              profile?.score !== null || profile.score !== undefined
                ? profile.score
                : null;
          } else {
            console.warn('*****Invalid score provided for started quest.');
            return;
          }
        }
        const currentQuestseqId = Array.isArray(currentScores)
          ? currentScores.map((item) => item.seqId)
          : [];
        if (Array.isArray(currentScores) && currentScores.length > 0) {
          const result = currentQuestseqId.map((seqId) => {
            const QuestNo = seqId?.split('.')[0];
            if (QuestNo == profile.currentQuest) {
              const filteredOptions = gameInfo?.questOptions?.filter(
                (option: any) => option.qpSequence == seqId,
              );

              const qpScoresOption = filteredOptions.map((option: any) =>
                parseInt(option.qpScore),
              );
              qpScoresOption.sort((a: any, b: any) => b - a);
              GrandMaximumscore += qpScoresOption[0];
            }
          });
        } else {
          console.warn('*****Options are not provided.');
        }
        return GrandMaximumscore;
      }
    };
    calculateQuestGrandTotal();
    if (currentScreenId === 2) {
      calculatePlayerGrandTotal();
    }
  }, [profile?.score, profile?.replayScore, currentScreenId]);
  useEffect(() => {
    if (
      !gameInfo?.gameData?.gameIntroMusicName &&
      !gameInfo?.gameData?.gameIntroMusic
    ) {
      // fetchDefaultBgMusic();
    } else if (
      gameInfo?.gameData?.gameIntroMusicName &&
      gameInfo?.gameData?.gameIntroMusic
    ) {
      const screens = [1, 12, 13];
      if (
        screens.includes(currentScreenId) &&
        ![2, 3, 4, 5, 6, 7, 0, 14].includes(currentScreenId)
      ) {
        setAudioObj((prev) => ({
          ...prev,
          url: gameInfo?.gameData?.gameIntroMusicName,
          type: EnumType.BGM,
          loop: false,
          autoplay: true,
        }));
      }
    }
  }, [gameInfo]);

  useEffect(() => {
    if (audio !== '') {
      if (![2, 3, 4, 5, 6, 7, 0, 14].includes(currentScreenId)) {
        setAudioObj((prev) => ({
          ...prev,
          url: audio,
          type: EnumType.BGM,
          loop: false,
          autoplay: true,
        }));
      }
    }
  }, [audio]);
  const prevTypeRef = useRef<string>();
  const prevVoiceUrlRef = useRef<string>('');
  const [isVisible, setIsVisible] = useState(
    document.visibilityState === 'visible',
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);


useEffect(() => {
    const handleAudio = (
      audioRef: React.RefObject<HTMLAudioElement>,
      audio: any,
    ) => {
      if (!audioRef.current) return;

      const currentSrc = audioRef.current.src;
      const isSameSrc = (() => {
        try {
          return new URL(currentSrc).href === new URL(audio.url).href;
        } catch {
          return currentSrc === audio.url;
        }
      })();

      if (!isSameSrc) {
        audioRef.current.src = audio.url;
      }
  if (currentScreenId === 17) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    return; 
  }
      // Update volume without stopping playback
      audioRef.current.volume = parseFloat(
        [2, 15, 14].includes(currentScreenId) &&
          document.visibilityState === 'visible'
          ? audio.Voicevolume
          : audio.BGMvolume,
      );

      // Handle play/pause only if the autoplay flag changed
      if (audio.autoplay) {
        if (audio.type === EnumType.BGM && backgroundBgmRef.current) {
          if (
            audioRef.current.paused &&
            ![2, 3, 4, 5, 6, 7, 0, 14].includes(currentScreenId)
          ) {
            audioRef.current.play().catch(console.error);
          }
        } else if (audio.type === EnumType.VOICE && voiceRef.current) {
          if (
            audioRef.current.paused &&
            document.visibilityState === 'visible' &&
            ![3, 4, 5, 6, 7, 0].includes(currentScreenId)
          ) {
            audioRef.current.play().catch(console.error);
          }
        }
      } else {
        if (!audioRef.current.paused) {
          // audioRef.current.pause();
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      }
    };

    // Only pause if we're changing audio type (not just volume)
    if (
      audioObj.type === EnumType.BGM &&
      prevTypeRef.current === EnumType.VOICE
    ) {
      // voiceRef.current?.pause();
      if (voiceRef.current) {
        voiceRef.current.pause();
        voiceRef.current.currentTime = 0; // IMPORTANT FIX
      }
    } else if (
      audioObj.type === EnumType.VOICE &&
      prevTypeRef.current === EnumType.BGM
    ) {
      // backgroundBgmRef.current?.pause();
      if (backgroundBgmRef.current) {
        backgroundBgmRef.current.pause();
        backgroundBgmRef.current.currentTime = 0;
      }
    }

    if (document.visibilityState === 'visible') {
      if (audioObj.type === EnumType.BGM) {
        handleAudio(backgroundBgmRef, audioObj);
      } else if (audioObj.type === EnumType.VOICE) {
        const nextVoiceUrl = audioObj?.url ?? '';
        if (voiceRef.current) {
          // Only reset to start when switching to a different voice track.
          if (nextVoiceUrl !== prevVoiceUrlRef.current) {
            voiceRef.current.pause();
            voiceRef.current.currentTime = 0;
          }
        }
        handleAudio(voiceRef, audioObj);
        prevVoiceUrlRef.current = nextVoiceUrl;
      }
    }
    if (hubDialogAudio) {
      handleAudio(audioRef, hubDialogAudio);
    }
    prevTypeRef.current = audioObj.type;
  }, [audioObj, document.visibilityState]);

 
  const handleMusicVolume = (sliderValue: number, type: string) => {
    if (!isNaN(sliderValue) && isFinite(sliderValue)) {
      const newVolume = sliderValue / 100;

      // Update the ref immediately for responsive feedback
      if (type === EnumType.BGM && backgroundBgmRef.current) {
        backgroundBgmRef.current.volume = newVolume;
        setLearnerPlayingDetails((prev: any) => ({
          ...prev,
          // audioVolumeValue: { bgmVolume: prev.audioVolumeValue.bgmVolume, voiceVolume: newVoiceVolume }
          audioVolumeValue: {
            bgmVolume:
              type === EnumType.BGM
                ? newVolume.toString()
                : learnerPlayList.audioVolumeValue.bgmVolume,
            voiceVolume:
              type === EnumType.VOICE
                ? newVolume.toString()
                : learnerPlayList.audioVolumeValue.voiceVolume,
          },
        }));
        setAudioObj((prev: any) => ({
          ...prev,
          type: type === EnumType.BGM ? EnumType.BGM : EnumType.VOICE, // Update type based on parameter
          Voicevolume:
            type === EnumType.VOICE
              ? newVolume.toString()
              : learnerPlayList?.audioVolumeValue?.voiceVolume
              ? learnerPlayList?.audioVolumeValue?.voiceVolume
              : 0.5,
          BGMvolume:
            type === EnumType.BGM
              ? newVolume.toString()
              : learnerPlayList?.audioVolumeValue?.bgmVolume
              ? learnerPlayList?.audioVolumeValue?.bgmVolume
              : 0.5,
        }));
      } else if (voiceRef.current) {
        voiceRef.current.volume = newVolume;
        setLearnerPlayingDetails((prev: any) => ({
          ...prev,
          // audioVolumeValue: { bgmVolume: prev.audioVolumeValue.bgmVolume, voiceVolume: newVoiceVolume }
          audioVolumeValue: {
            bgmVolume:
              type === EnumType.BGM
                ? newVolume.toString()
                : learnerPlayList.audioVolumeValue.bgmVolume,
            voiceVolume:
              type === EnumType.VOICE
                ? newVolume.toString()
                : learnerPlayList.audioVolumeValue.voiceVolume,
          },
        }));
        setAudioObj((prev: any) => ({
          ...prev,
          type: type === EnumType.BGM ? EnumType.BGM : EnumType.VOICE, // Update type based on parameter
          Voicevolume:
            type === EnumType.VOICE
              ? newVolume.toString()
              : learnerPlayList?.audioVolumeValue?.voiceVolume
              ? learnerPlayList?.audioVolumeValue?.voiceVolume
              : 0.5,
          BGMvolume:
            type === EnumType.BGM
              ? newVolume.toString()
              : learnerPlayList?.audioVolumeValue?.bgmVolume
              ? learnerPlayList?.audioVolumeValue?.bgmVolume
              : 0.5,
        }));
      }

      // Update state for persistence
      setAudioObj((prev) => ({
        ...prev,
        [type === EnumType.BGM ? EnumType.BGM : EnumType.VOICE]:
          newVolume.toString(),
      }));
    }
  };

  useEffect(() => {
    if (gameInfo) {
      setVoiceIds({
        narrator:
          gameInfo?.gameData?.gameNarratorVoice ?? 'D38z5RcWu1voky8WS1ja',
        playerMale:
          gameInfo?.gameData?.gamePlayerMaleVoice ?? '2EiwWnXFnvU5JabPnv8n',
        playerFemale:
          gameInfo?.gameData?.gamePlayerFemaleVoice ?? '21m00Tcm4TlvDq8ikWAM',
        NPC: gameInfo?.gameData?.gameNonPlayerVoice ?? '5Q0t7uMcjvnagumLfvZi',
        Intro: '',
      });
    }
  }, [gameInfo?.gameData]);
  useEffect(() => {
    if (![2, 3, 4, 5, 6, 7, 0, 14].includes(currentScreenId)) {
      if (
        !gameInfo?.gameData?.gameIntroMusicName &&
        !gameInfo?.gameData?.gameIntroMusic
      ) {
        setAudio('');
        setAudioObj((prev) => ({
          ...prev,
          url: '',
          type: EnumType.BGM,
          loop: false,
          autoplay: true,
        }));
      } else {
        if (
          gameInfo?.gameData?.gameIntroMusicName &&
          gameInfo?.gameData?.gameIntroMusic
        ) {
          setAudio(gameInfo?.gameData?.gameIntroMusicName);
        }
      }
    }
  }, [currentScreenId, gameInfo]);

  

  const LastModiPrevData = async (current: any = null) => {
    if (isAudioPaused) {
      toggleAudioPlayPause();
    }
    if (!OptionalReplayTracked) {
      setOptionalReplayTracked(true);
    }
    let NextSeqBlock: any;
    if (walkanimation) {
      setWalkanimation(false);
    }
    if (nextcharacter !== '') {
      setNextcharacter('');
    }
    setSelectedOption(null);
    setRepeatPrevOption([]);
    setRepeatSelectOption(false);

    if (type !== 'Interaction') {
      if (type === 'response' && resMsg !== '') {
        setType(current?.blockChoosen);
        setData(current);
        if (current?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          setType(current?.blockChoosen);
          for (const option of gameInfo.questOptions) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }
          setOptions(optionsFiltered);

          return false;
        }
        return false;
      }
      if (type === 'feedback' && feed !== '' && resMsg !== '') {
        setType('response');
        setData(current);
        const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
          (key: any) => key?.textId === OptionSelectId,
        );
        if (optionAudioFiltered.length > 0) {
          const responseAudioFiltered = optionAudioFiltered.filter(
            (key: any) => key?.fieldName === 'qpResponse',
          );
          const FilteredResponsecontent = responseAudioFiltered[0].content;
          setResMsg(FilteredResponsecontent);
        } else {
          setResMsg(resMsg);
        }
        return false;
      }
      if (type === 'feedback' && feed !== '' && resMsg === '') {
        setType(current?.blockChoosen);
        setData(current);
        if (current?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];
          for (const option of gameInfo.questOptions) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === current?.blockPrimarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }

          setOptions(optionsFiltered);
          return false;
        }
        return false;
      }
    }
    // else
    // {
    //       // handlePreviousBlock(current?.blockSecondaryId, current?.blockQuestNo,NextSeqBlock);

    // }



    const valuesArray =
      demoBlocks && demoBlocks[current?.blockQuestNo]
        ? Object.values(demoBlocks[current?.blockQuestNo])
        : null;
    const currentIndex = valuesArray
      ? valuesArray?.findIndex(
          (item: any) =>
            item.blockPrimarySequence === current?.blockPrimarySequence,
        )
      : 0;

    if (currentIndex > 0) {
      NextSeqBlock = valuesArray[currentIndex - 1];
    } else {
      NextSeqBlock = null;
    }

    handlePreviousBlock(
      current?.blockSecondaryId,
      current?.blockQuestNo,
      NextSeqBlock,
    );
  };

  const setInteractionOptions = (gameInfo: any, currentBlock: any) => {
    const optionsFiltered = [];
    for (const option of gameInfo.questOptions) {
      if (profileData?.Audiogetlanguage.length > 0) {
        if (option?.qpSequence === currentBlock?.blockPrimarySequence) {
          const profilesetlan = profileData?.Audiogetlanguage.find(
            (key: any) => key?.textId === option.qpOptionId,
          );

          if (profilesetlan) {
            const languagecont = {
              ...option,
              qpOptionText: profilesetlan.content,
            };
            optionsFiltered.push(languagecont);
          } else {
            optionsFiltered.push(option);
          }
        }
      } else {
        if (option?.qpSequence === currentBlock?.blockPrimarySequence) {
          optionsFiltered.push(option);
        }
      }
    }
    if (gameInfo?.gameData?.gameShuffle === 'true') {
      for (let i = optionsFiltered.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [optionsFiltered[i], optionsFiltered[j]] = [
          optionsFiltered[j],
          optionsFiltered[i],
        ];
      }
      setOptions(optionsFiltered);
    }
  };
  const BlockSeqNextPreviousNotes = async (inputId?: any, questNo?: any) => {
    if (inputId !== null) {
      const currentQuest = questNo;
      const founditem: any = Object.values(demoBlocks[questNo])?.filter(
        (item: any) => item?.blockSecondaryId === inputId,
      );
      const foundNavi = profile?.score?.filter(
        (item: any) => item.seqId == founditem[0]?.blockPrimarySequence,
      );
      const getOption = foundNavi[0]?.choosedoption ?? null;
      if (getOption) {
        const optionsFiltered = [];

        for (const option of gameInfo?.questOptions) {
          if (option?.qpSequence === founditem[0]?.blockPrimarySequence) {
            optionsFiltered.push(option);
          }
        }
        if (optionsFiltered) {
          const getFilterOption = optionsFiltered.filter(
            (item: any) => item?.qpOptions === getOption,
          );
          if (getFilterOption) {
            if (getFilterOption[0]?.qpNextOption === 'Repeat Question') {
              setFeed('');
              setRepeatSelectOption(true);
              RepeatPrevOption.push(getOption);
              setRepeatPrevOption(RepeatPrevOption);
            }
          }
        }
      }
      if (learnerPlayList?.Prevquestseq) {
        if (learnerPlayList?.Prevquestseq[currentQuest]) {
          if (
            !learnerPlayList?.Prevquestseq[currentQuest].includes(
              founditem[0]?.blockPrimarySequence,
            )
          ) {
            setLearnerPlayingDetails((prev: any) => ({
              ...prev,
              Prevquestseq: {
                ...prev.Prevquestseq,
                [currentQuest]: [
                  ...(prev.Prevquestseq[currentQuest] || []),
                  founditem[0]?.blockPrimarySequence,
                ],
              },
            }));
          }
        } else {
          setLearnerPlayingDetails((prev: any) => ({
            ...prev,
            Prevquestseq: {
              ...prev.Prevquestseq,
              [currentQuest]: [founditem[0]?.blockPrimarySequence],
            },
          }));
        }
      } else {
        setLearnerPlayingDetails((prev: any) => ({
          ...prev,
          Prevquestseq: {
            [currentQuest]: [founditem[0]?.blockPrimarySequence],
          },
        }));
      }
      const existsInPrevBlock =
        prevBlock &&
        prevBlock.some(
          (block: any) => block === founditem[0]?.blockPrimarySequence,
        );
      if (!existsInPrevBlock) {
        setprevBlock((prev: any) => [
          ...prev,
          founditem[0]?.blockPrimarySequence,
        ]);
      }
    }
  };

  const handlePreviousBlock = async (
    inputid?: any,
    questNo?: any,
    PrevNaviSeqBlock?: any,
  ) => {
    const questKey = String(questNo);
    const questBlocks = demoBlocks?.[questKey] ?? demoBlocks?.[Number(questKey)] ?? {};

    const founditem: any = Object.keys(questBlocks)
      .filter((item: any) => {
        return (
          questBlocks[item]?.blockSecondaryId === parseInt(inputid)
        );
      })
      .map((item: any) => {
        return questBlocks[item];
      });
    const lastSeq = learnerPlayList?.Prevquestseq?.[questKey] ?? [];
    const secondLastSeq = lastSeq ? lastSeq[lastSeq.length - 2] : null;
    if (learnerPlayList?.Prevquestseq?.[questKey]) {
      let updateNavigateSeq: any = [...learnerPlayList?.Prevquestseq?.[questKey]];
      updateNavigateSeq.pop();
      if (secondLastSeq != updateNavigateSeq[updateNavigateSeq.length - 1]) {
        updateNavigateSeq.push(founditem[0]?.blockPrimarySequence);
      }
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        Prevquestseq: { ...prev.Prevquestseq, [questKey]: updateNavigateSeq },
      }));
    }

    // Keep only history entries that belong to this quest.
    const questSequences = new Set(
      Object.values(questBlocks).map((b: any) => b?.blockPrimarySequence),
    );
    const prevBlockForQuest = (Array.isArray(prevBlock) ? prevBlock : []).filter(
      (seq: any) => questSequences.has(seq),
    );

    if (Array.isArray(prevBlock) && prevBlockForQuest.length !== prevBlock.length) {
      setprevBlock(prevBlockForQuest);
    }

    let prev = prevBlockForQuest[prevBlockForQuest?.length - 1];

    let getBlocks: any;
    
    if (prev) {
      getBlocks = Object.values(questBlocks).filter(
        (item: any) => item?.blockPrimarySequence === prev,
      );
      setprevBlock(prevBlockForQuest.slice(0, -1));
    } else {
      getBlocks = Object.values(questBlocks).filter(
        (item: any) =>
          item?.blockPrimarySequence === PrevNaviSeqBlock?.blockPrimarySequence,
      );
    }
    let total = 0;
    let updatedscore: any = [];
    if (questState[parseInt(profile?.currentQuest)] === 'Started') {
      // Remove matching object from profile?.score
      updatedscore = profile?.score;
    } else if (
      questState[parseInt(profile?.currentQuest)] === 'replayallowed'
    ) {
      // Remove matching object from profile?.replayScore
      updatedscore = profile?.replayScore;
    } else {
      updatedscore = profile?.score;
    }
    const scoreArray = updatedscore;
   
    if (scoreArray?.length > 0) {
      // STEP 2: Apply filter with logs
      const filteredData = scoreArray?.filter((cur: any, index: number) => {
        const isValidStructure =
          cur.seqId &&
          cur.scenarioId !== undefined &&
          cur.choosedoption !== undefined;

        const isQuestMatch = Number(cur.quest) === Number(profile.currentQuest);

        const finalResult = isValidStructure && isQuestMatch;

        return finalResult;
      });

      // STEP 3: Reduce with logs
      total = filteredData?.reduce((sum: number, cur: any, index: number) => {
        const score = Number(cur.score || 0);

        return sum + score;
      }, 0);
    }
    const data = {
      blockname: type,
      galAverageScore: total,
      galBlockId: inputid,
      galblockleft : getBlocks[0]?.blockSecondaryId,
      gameId: learner_game_play_id,
      galAssignedId:AssignId,
      galTimeSpent: formatTime(seconds),
      navigateId:getBlocks[0]?.blockShowNavigate
      
    };
    
    const actId1 = Activitydata;
    const datas = JSON.stringify(data);
    const result = await activityUpdate(datas, actId1);
    setLoadingProgress(5);
    if (result.status !== 'Success') {
      return false;
    }
    setData(getBlocks[0]);
    setType(getBlocks[0]?.blockChoosen);
    if (getBlocks[0]?.blockChoosen === 'Interaction') {
      const optionsFiltered = [];
      const primarySequence = getBlocks[0].blockPrimarySequence;

      for (const option of gameInfo.questOptions) {
        if (profileData?.Audiogetlanguage.length > 0) {
          if (option?.qpSequence === primarySequence) {
            const profilesetlan = profileData?.Audiogetlanguage.find(
              (key: any) => key?.textId === option.qpOptionId,
            );

            if (profilesetlan) {
              const languagecont = {
                ...option,
                qpOptionText: profilesetlan.content,
              };
              optionsFiltered.push(languagecont);
            } else {
              optionsFiltered.push(option);
            }
          }
        } else {
          if (option?.qpSequence === primarySequence) {
            optionsFiltered.push(option);
          }
        }
      }
      if (gameInfo?.gameData?.gameShuffle === 'true') {
        for (let i = optionsFiltered.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [optionsFiltered[i], optionsFiltered[j]] = [
            optionsFiltered[j],
            optionsFiltered[i],
          ];
        }
      }
      setOptions(optionsFiltered);
    }
  };


  const storage = JSON.parse(localStorage.getItem('user'));

  const toggleAudioPlayPause = useCallback(() => {
    if (isAudioPaused) {
      // Resume audio
      if (backgroundBgmRef.current && backgroundBgmRef.current.src) {
        backgroundBgmRef.current.play().catch(console.error);
      }
      if (voiceRef.current && voiceRef.current.src) {
        voiceRef.current.play().catch(console.error);
      }
      setIsAudioPaused(false);
      setIsAnimationPaused(false);
    } else {
      // Pause audio
      if (backgroundBgmRef.current && !backgroundBgmRef.current.paused) {
        backgroundBgmRef.current.pause();
      }
      if (voiceRef.current && !voiceRef.current.paused) {
        voiceRef.current.pause();
      }
      setIsAudioPaused(true);
      setIsAnimationPaused(true);
    }
  }, [isAudioPaused, isAnimationPaused]);
  useEffect(() => {
    const fetchgetTimespent = async () => {
      try {
        let datatoSend = {
          gameid: learner_game_play_id,
          learnerId: storage?.data?.id,
        };
        const response = await getTimespent(JSON.stringify(datatoSend));

        // setTotalTimeSpended(response?.data);
      } catch (error) {
        console.error('Error fetching totalTimeSpent:', error);
        // setTotalTimeSpent("0:00");
      }
    };
    setLoadingProgress(90);
    fetchgetTimespent();
  }, []);

  const [isInteractionButtonDisabled, setIsInteractionButtonDisabled] =
    useState(false);
  const handleInteractionBackClick = (data: any) => {
    if (isInteractionButtonDisabled) return;
    setIsInteractionButtonDisabled(true);

    const valuesArray =
      demoBlocks && demoBlocks[data?.blockQuestNo]
        ? (Object.values(demoBlocks[data.blockQuestNo]) as any[])
        : [];

    const currentIndex = valuesArray.findIndex(
      (item: any) => item.blockPrimarySequence === data?.blockPrimarySequence,
    );

    const currentBlock = valuesArray[currentIndex];
    const seqIdToClear = currentBlock?.blockPrimarySequence ?? null;

    if (seqIdToClear) {
      // ✅ Only clear if NO score saved yet
      const hasScore =
        profile?.score?.some((s: any) => s.seqId === seqIdToClear) ||
        profile?.replayScore?.some((s: any) => s.seqId === seqIdToClear);

      if (!hasScore) {
        setProfile((prev: any) => {
          const newScore = Array.isArray(prev.score)
            ? prev.score.filter((s: any) => s.seqId !== seqIdToClear)
            : prev.score;
          const newReplay = Array.isArray(prev.replayScore)
            ? prev.replayScore.filter((s: any) => s.seqId !== seqIdToClear)
            : prev.replayScore;
          return { ...prev, score: newScore, replayScore: newReplay };
        });

        try {
          if (typeof window !== 'undefined') {
            sessionStorage.setItem(`clearedSeq_${seqIdToClear}`, '1');
          }
        } catch (e) {}
      }

      // ⚙️ Don’t reset everything globally — only local UI state
      if (typeof setScore === 'function') setScore(null);
      if (typeof setSelectedOption === 'function') setSelectedOption(null);
      if (typeof setRepeatPrevOption === 'function') setRepeatPrevOption([]);
      if (typeof setRepeatSelectOption === 'function')
        setRepeatSelectOption(false);
    }

    LastModiPrevData(data);
    setTimeout(() => setIsInteractionButtonDisabled(false), 2000);
  };
  const CompletionScreenFunction = (next?: any) => {
    const { currentGameData, nextLevel } = calScore();
    if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
      setCurrentScreenId(4); //Navigate to leaderboard
      return false;
    } else {
      LeaderBoardFunc(next);
    }
  };

  const AfterCompletionFeedBackFunc = () => {
    const { currentGameData, nextLevel } = calScore();
    (async () => {
      const finalscore = await getPlayerFinalScore(
        profile?.score,
        currentGameData,
      );

      const isMandatoryReplayPromptRequired =
        await checkIsMandatoryReplayPromptRequired(
          Number(finalscore),
          currentGameData,
        );

      const isOptionalReplayAllowed = await isOptionalReplayAllow(
        Number(finalscore),
        currentGameData,
        gameInfo.gameData?.gameDisableOptionalReplays,
      );
      if (isMandatoryReplayPromptRequired) {
        Setprofilescore(finalscore);
        setReplayState('mandatoryReplay');
         setlearnerActivityrec((prev: any) =>
            updateScreenActivity(
              prev,
              99,
              "Replay Prompt",
              deviceInfo,
              {
                replyPromptopen:true,
                replyPromptclose:false,
                promptscenario : 'mandatoryReplay',
                replayplayaction : false
              }
            )
          );
        setReplayIsOpen(true);
        return;
      } else if (isOptionalReplayAllowed) {
        setReplayState('optionalReplay');
         setlearnerActivityrec((prev: any) =>
            updateScreenActivity(
              prev,
              99,
              "Replay Prompt",
              deviceInfo,
              {
                replyPromptopen:true,
                replyPromptclose:false,
                promptscenario : 'optionalReplay',
                replayplayaction : false
              }
            )
        );
        setReplayIsOpen(true);
        return;
      } else if (demoBlocks.hasOwnProperty(nextLevel)) {
        setProfile((prev: any) => {
          const data = { ...prev };
          if (!profile.completedLevels.includes(String(nextLevel))) {
            data.completedLevels = [...data.completedLevels, String(nextLevel)];
          }
          return data;
        });

        setType(demoBlocks[nextLevel]['1']?.blockChoosen);
        setData(demoBlocks[nextLevel]['1']);
        setMotionEffect(true);
        setCurrentScreenId(13);
        return false;
      } else if (gameInfo?.gameData?.gameIsShowReflectionScreen === 'true') {
        setCurrentScreenId(3); //reflection screen
        return false;
      } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
        setCurrentScreenId(7); //takeaway
        return false;
      } else {
        setType(null);
        setData(null);
        setCurrentScreenId(13); //thank you screen
        return false;
      }
    })();
  };
  const ReplayGameFunc = () => {
    if (gameInfo?.gameData?.gameIsShowLeaderboard === 'true') {
      setCurrentScreenId(4);
      return false;
    } else if (gameInfo?.gameData?.gameIsShowReflectionScreen === 'true') {
      setCurrentScreenId(3);
      return false;
    } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
      setCurrentScreenId(7);
      return false;
    } else {
      if (data && type) {
        setCurrentScreenId(2);
        return false;
      } else {
        setType(null);
        setData(null);
        setCurrentScreenId(13);
        return false;
      }
    }
  };
  const LeaderBoardFunc = (nextLevel?: any) => {
    checkAndUpdateScores();
    const Nextcurrentquest = profile?.currentQuest;
    const getgameinfoquest = gameInfo?.gameQuest.find(
      (row: any) => row.gameQuestNo == Nextcurrentquest,
    );
    (async () => {
      const finalscore = await getPlayerFinalScore(
        profile?.score,
        getgameinfoquest,
      );
      const isMandatoryReplayPromptRequired =
        await checkIsMandatoryReplayPromptRequired(
          Number(finalscore),
          getgameinfoquest,
        );
      const isOptionalReplayAllowed = await isOptionalReplayAllow(
        Number(finalscore),
        getgameinfoquest,
        gameInfo.gameData?.gameDisableOptionalReplays,
      );
      if (gameInfo?.interactionfeedback === 'Completion') {
        if (
          feedbackList?.length !== 0 &&
          feedbackList?.find((item: any) => item.quest == profile?.currentQuest)
        ) {
          getFeedbackData(data);
          // setFeedbackNavigateNext(false);
          // setCurrentScreenId(14);
          startTransition(() => {
            setFeedbackNavigateNext(false);
            setCurrentScreenId(14); // <-- likely causing Suspense
          });
          if (demoBlocks.hasOwnProperty(nextLevel)) {
            setProfile((prev: any) => {
              const data = { ...prev };
              if (!profile.completedLevels.includes(String(nextLevel))) {
                data.completedLevels = [
                  ...data.completedLevels,
                  String(nextLevel),
                ];
              }
              return data;
            });
          }
          return false;
        } else if (isMandatoryReplayPromptRequired) {
          Setprofilescore(finalscore);
          setReplayState('mandatoryReplay');
           setlearnerActivityrec((prev: any) =>
            updateScreenActivity(
              prev,
              99,
              "Replay Prompt",
              deviceInfo,
              {
                replyPromptopen:true,
                replyPromptclose:false,
                promptscenario : 'mandatoryReplay',
                replayplayaction : false
              }
            )
          );
          setReplayIsOpen(true);
          return;
        } else if (isOptionalReplayAllowed) {
          setReplayState('optionalReplay');
           setlearnerActivityrec((prev: any) =>
            updateScreenActivity(
              prev,
              99,
              "Replay Prompt",
              deviceInfo,
              {
                replyPromptopen:true,
                replyPromptclose:false,
                promptscenario : 'optionalReplay',
                replayplayaction : false
              }
            )
          );
          setReplayIsOpen(true);
          return;
        } else {
          if (demoBlocks.hasOwnProperty(nextLevel)) {
            setFeedbackNavigateNext(false);
            setProfile((prev: any) => {
              const data = { ...prev };
              if (!profile.completedLevels.includes(String(nextLevel))) {
                data.completedLevels = [
                  ...data.completedLevels,
                  String(nextLevel),
                ];
              }
              return data;
            });
            setType(demoBlocks[nextLevel]['1']?.blockChoosen);
            setData(demoBlocks[nextLevel]['1']);
            setMotionEffect(true);
            setCurrentScreenId(13);
            return false;
          } else if (
            gameInfo?.gameData?.gameIsShowReflectionScreen === 'true'
          ) {
            setCurrentScreenId(3);
            return false;
          } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
            setCurrentScreenId(7);
            return false;
          } else {
            setType(null);
            setData(null);
            setCurrentScreenId(13);
            return false;
          }
        }
      } else if (isMandatoryReplayPromptRequired) {
        Setprofilescore(finalscore);
        setReplayState('mandatoryReplay');
        setReplayIsOpen(true);
        return;
      } else if (isOptionalReplayAllowed) {
        setReplayState('optionalReplay');
        setReplayIsOpen(true);
        return;
      } else if (demoBlocks.hasOwnProperty(nextLevel)) {
        setFeedbackNavigateNext(false);
        setProfile((prev: any) => {
          const data = { ...prev };
          if (!profile.completedLevels.includes(String(nextLevel))) {
            data.completedLevels = [...data.completedLevels, String(nextLevel)];
          }
          return data;
        });
        setType(demoBlocks[nextLevel]['1']?.blockChoosen);
        setData(demoBlocks[nextLevel]['1']);
        setMotionEffect(true);
        setCurrentScreenId(13);
        return false;
      } else if (gameInfo?.gameData?.gameIsShowReflectionScreen === 'true') {
        setCurrentScreenId(3);
        return false;
      } else if (gameInfo?.gameData?.gameIsShowTakeaway === 'true') {
        setCurrentScreenId(7);
        return false;
      } else {
        setType(null);
        setData(null);
        setCurrentScreenId(13);
        return false;
      }
    })();
  };
  const calcQuestGrandTotal = async (
    scores: any,
    currentQuestNo: any = null,
  ) => {
    if (scores?.length <= 0) {
      return 0;
    }

    if (currentQuestNo != null) {
      // Sum score of a quest
      const totalScore = scores.reduce((total: number, sc: any) => {
        if (sc.quest == currentQuestNo) {
          return total + sc.score;
        } else {
          return total;
        }
      }, 0);
      return totalScore; // Return the total score
    } else {
      //Sum up all the scores
      return scores.reduce((total: number, sc: any) => total + sc.score, 0);
    }
  };

  const originalScore = async () => {
    const currentQuest = profile.currentQuest;
    const scoreTotal = await calcQuestGrandTotal(
      profile.score,
      profile.currentQuest,
    );

    if (questState[profile?.currentQuest] === 'Started') {
      setLearnerPlayingDetails((prev: any) => ({
        ...prev,
        firstTryScore: [
          ...prev.firstTryScore,
          { quest: currentQuest, score: scoreTotal },
        ],
      }));
    }
  };
  const checkAndUpdateScores = async () => {
    const currentQuest = profile.currentQuest;
    // if (questState[currentQuest] !== 'Started') {
    const scoreTotal = await calcQuestGrandTotal(
      profile.score,
      profile.currentQuest,
    );

    const replayScoreTotal = await calcQuestGrandTotal(
      profile.replayScore,
      profile.currentQuest,
    );

    if (scoreTotal <= replayScoreTotal) {
      const currentQuestRemovedScoreArr = profile.score.filter(
        (item: any) => item.quest != profile.currentQuest,
      );
      let concatenatedScoreArr: any[] = [];
      if (profile.replayScore.length > 0) {
        concatenatedScoreArr = profile.replayScore.filter(
          (item: any) => item.quest == profile.currentQuest,
        );
      }
      if (currentQuestRemovedScoreArr.length > 0) {
        concatenatedScoreArr = [
          ...concatenatedScoreArr,
          ...currentQuestRemovedScoreArr,
        ];
      }
      const currentQuestRemovedReplayScoreArr = profile.replayScore.filter(
        (item: any) => item.quest != profile.currentQuest,
      );
      // const getScore = concatenatedScoreArr.length > 0 ? concatenatedScoreArr : profile.score;
      setProfile((prev: any) => ({
        ...prev,
        score: concatenatedScoreArr,
        replayScore: currentQuestRemovedReplayScoreArr,
      }));
    } else {
      const currentQuestRemovedReplayScoreArr = profile.replayScore.filter(
        (item: any) => item.quest != profile.currentQuest,
      );
      setProfile((prev: any) => ({
        ...prev,
        replayScore: currentQuestRemovedReplayScoreArr,
      }));
    }
  };
console.log(profile,'profileinggame')
 
  const checkCompletionBadge = () => {
  // 🔧 Only addition: also look for completeBadgseShow outside of profile,
  // in case it lives on assignedData / learnerPlayList for some learners.
  const outsideBadgeList =
    (assignedData as any)?.completeBadgseShow ??
    (learnerPlayList as any)?.completeBadgseShow ??
    null;

  setProfile((prev: any) => {
    const data = { ...prev };

    // Prefer profile's own list; if missing/not an array, fall back to outside one
    const sourceList = Array.isArray(profile?.completeBadgseShow)
      ? profile?.completeBadgseShow
      : Array.isArray(outsideBadgeList)
      ? outsideBadgeList
      : [];

    if (sourceList?.length === 0) {
      data.completeBadgseShow = [String(profile?.currentQuest)];
    } else if (!sourceList.includes(String(profile?.currentQuest))) {
      data.completeBadgseShow = [...sourceList, String(profile?.currentQuest)];
    } else {
      data.completeBadgseShow = sourceList;
    }

    return data;
  });
};
  const fetchquestScore = async () => {
    const data = {
      gameId: gameInfo.gameData.gameId,
      // questNo: gameInfo.gameData.gameQuestNo,
      questNo: profile.currentQuest,
      learnerid: learnerPlayList.playerId,
    };

    try {
      const result = await questScore(JSON.stringify(data));

      if (result.status === 'Success') {
        setGetScore(result?.maxScore || 0);
      }
    } catch (error) {
      console.error('Error fetching quest score', error);
    }
  };

 
 
  const fetchblockScore = async (getscore: any) => {
    const data1 = {
      gameId: gameInfo.gameData.gameId,
      questNo: profile.currentQuest,
      blockname: data?.blockChoosen,
      galBlockId: data?.blockSecondaryId,
       galblockleft : data?.blockSecondaryId,
      scenarioid: data?.blockScenario,
      interactionfeedback: data?.interactionfeedback,
      selectedOption: getscore?.selectedOptioncheck,
    };

    try {
      const result = await blockScore(JSON.stringify(data1));

      if (result.status === 'Success') {
        const score = result?.blockScore || 0;

        setGetIntractionscore(score); // keep if UI needs it
        return score; // ✅ IMPORTANT
      }
    } catch (error) {
      console.error('Error fetching quest score', error);
    }

    return 0;
  };
  //  useEffect(() => {
  //   fetchblockScore()
  // }, [score])
  useEffect(() => {
    fetchquestScore();
  }, []);
const [isFetching, setIsFetching] = useState(false);
  // const getData = async (next: any) => {
  const getDataCore  = async (next: any) => {
   
      const defer = (fn: () => void) => { pendingMoveRef.current.push(fn); };
  const setType = (v: any) => defer(() => setTypeReal(v));
  const setData = (v: any) => defer(() => setDataReal(v));
  const setOptions = (v: any) => defer(() => setOptionsReal(v));
  const setCurrentScreenId = (v: any) => defer(() => setCurrentScreenIdReal(v));
  const setReplayIsOpen = (v: any) => defer(() => setReplayIsOpenReal(v));
  const setReplayState = (v: any) => defer(() => setReplayStateReal(v));

    // fetchblockScore()
    if (isAudioPaused) {
      toggleAudioPlayPause();
    }

    await forceStopAllAudio();
    if (navi === '' || navi !== 'Repeat Question') {
      setRepeatPrevOption([]);
      setRepeatSelectOption(false);
    }
    setSelectedOption(null);
    if (currentScreenId === 2) {
      BlockSeqNextPreviousNotes(next?.blockSecondaryId, next?.blockQuestNo);
    }

    if (
      next?.blockChoosen === 'Interaction' &&
      gameInfo?.gameData?.gameIsShowInteractionFeedBack === 'Completion'
    ) {
      const isDuplicate = feedbackList?.some(
        (item: any) =>
          item.Seq === next?.blockPrimarySequence &&
          item.Options === getSelectedOptions,
      );

      if (!isDuplicate) {
        if (feed !== '' && feedbackList.length > 0) {
          setFeedbackList((prevFeedbackList:any) => [
            ...prevFeedbackList,
            {
              quest: next?.blockQuestNo,
              feedbackcontent: feed,
              type: navi,
              Seq: next?.blockPrimarySequence,
              Options: getSelectedOptions,
              totalPoints: playerTodayScore,
              // sundar
              interactionfeedback: getSelectedOptions?.interactionfeedback,
              qpFeedback: getSelectedOptions?.qpFeedback,
            },
          ]);
          setinteractionfeedback(getSelectedOptions?.interactionfeedback);
        } else if (feed !== '' && feedbackList.length === 0) {
          setFeedbackList([
            {
              quest: next?.blockQuestNo,
              feedbackcontent: feed,
              type: navi,
              Seq: next?.blockPrimarySequence,
              Options: getSelectedOptions,
              totalPoints: playerTodayScore,
              // sundar
              interactionfeedback: getSelectedOptions?.interactionfeedback,
              qpFeedback: getSelectedOptions?.qpFeedback,
            },
          ]);
          setinteractionfeedback(getSelectedOptions?.interactionfeedback);
        }
      }
    }
    // sundar
    else if (
      next?.blockChoosen === 'ScenarioCompletion' &&
      gameInfo?.interactionfeedback === 'Completion'
    ) {
      setCurrentScreenId(14);
    }
    const currentBlock = next
      ? parseInt(next?.blockPrimarySequence.split('.')[1])
      : null;
    const quest = next ? next?.blockPrimarySequence.split('.')[0] : null;
    const valuesArray =
      demoBlocks && demoBlocks[quest] ? Object.values(demoBlocks[quest]) : null;
    const currentIndex = valuesArray
      ? valuesArray?.findIndex(
          (item: any) =>
            item.blockPrimarySequence === next?.blockPrimarySequence,
        )
      : 0;
    let NextSeqBlock: any;
    if (currentIndex > 0) {
      NextSeqBlock = valuesArray[currentIndex + 1];
    } else {
      NextSeqBlock = null;
    }
    const NextItem =
      NextSeqBlock != null
        ? parseInt(NextSeqBlock?.blockPrimarySequence.split('.')[1])
        : null;
    const nextSeq = next
      ? `${next?.blockPrimarySequence.split('.')[0]}.${NextItem}`
      : '';
    const currentQuest = next
      ? parseInt(next?.blockPrimarySequence.split('.')[0])
      : null;
    setCurrentQuestNo(currentQuest);
    const nextLevel = parseInt(profile?.currentQuest) + 1 || null;
    const nextBlock = next
      ? Object.keys(demoBlocks[quest] || {})
          .filter(
            (key) => demoBlocks[quest]?.[key]?.blockPrimarySequence === nextSeq,
          )
          .map((key: any) => demoBlocks[quest]?.[key])
      : [];
      let upcomingBlockId: any;
      const conditionTypes = ['Interaction', 'response', 'feedback']
           if (
        (type !== 'ScenarioCompletion') &&
        !conditionTypes.includes(type) &&
        (
          next?.blockShowNavigate === 'New Block' ||
          next?.blockShowNavigate === 'Select Block'
        )
      ) {
      const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(next?.blockLeadTo)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
        // ✅ manually selected block
        if (selectedNext && selectedNext.length > 0) {
          upcomingBlockId = selectedNext[0]?.blockSecondaryId;
        }else{
          if (nextBlock[0] !== undefined) {
             upcomingBlockId = nextBlock[0]?.blockSecondaryId;
          }else{
             upcomingBlockId = demoBlocks[quest]['1']?.blockSecondaryId;
          }
        }

      }else if( (type !== 'ScenarioCompletion') &&
        conditionTypes.includes(type) &&
        (
          next?.blockShowNavigate === 'New Block' ||
          next?.blockShowNavigate === 'Select Block'
        )){
        const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(optionNavigation)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
        // ✅ manually selected block
        if (selectedNext && selectedNext.length > 0) {
          upcomingBlockId = selectedNext[0]?.blockSecondaryId;
        }else{
          if (nextBlock[0] !== undefined) {
             upcomingBlockId = nextBlock[0]?.blockSecondaryId;
          }else{
             upcomingBlockId = demoBlocks[quest]['1']?.blockSecondaryId;
          }
        }
      } else {
        // fallback
        upcomingBlockId = next?.blockSecondaryId;
      }
    
    if (currentScreenId === 2) {
      let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == next?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == next?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == next?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      const data = {
        blockname: type,
        galAverageScore: total,
        galBlockId: next?.blockSecondaryId,
        galAssignedId:AssignId,
        galblockleft : upcomingBlockId,
        gameId: learner_game_play_id,
        galTimeSpent: formatTime(seconds),
        navigateId: !conditionTypes.includes(type)
          ? next?.blockShowNavigate
          : navi,
      };
      const actId1 = Activitydata;
      const datas = JSON.stringify(data);
      const result = await activityUpdate(datas, actId1);
      setLoadingProgress(10);
      if (result.status !== 'Success') {
        return false;
      } else {
        let getScore = 0;

        const selectedOptions = foundOption ? foundOption : null;

        if (
          conditionTypes.includes(type) &&
          selectedOptions &&
          selectedOptions.score !== undefined &&
          selectedOptions.score !== null
        ) {
          getScore = selectedOptions.score;
        }

        const histdata = {
          histActivityId: result?.updatedData?.galId,
          histGameId: result?.updatedData?.galGameId,
          histQuestNo: result?.updatedData?.galQuestNo,
          histBlockId: result?.updatedData?.galBlockId,
          histType: type,
          histNavigateTo: !conditionTypes.includes(type)
            ? next?.blockShowNavigate
            : navi,
          histOption: foundOnlyOption ? foundOnlyOption : null,
          // histScore: getScore !== null && !isNaN(getScore) ? getScore : null,
          // histScore: getIntractionscore,
          // histScore: scoreRef.current,
           histScore:type === 'Interaction'? lastInteractionScore : getScore,
        };

     

        const stringhistdata = JSON.stringify(histdata);
        if (learner_game_play_id) {
          const historyResult = await createGamePlayHistory(stringhistdata);
           setLastInteractionScore(0);
        }
        setLoadingProgress(30);
      }
      const currentDataOfBlocks = Object.values(
        demoBlocks[next?.blockQuestNo],
      ).filter(
        (item: any) =>
          item?.blockPrimarySequence === nextBlock[0]?.blockPrimarySequence,
      );

      for (let key in demoBlocks[next?.blockQuestNo]) {
        if (demoBlocks[next?.blockQuestNo].hasOwnProperty(key)) {
          const block = demoBlocks[next?.blockQuestNo][key];
          const isMatchingBlock = currentDataOfBlocks.some(
            (currentBlock) =>
              JSON.stringify(currentBlock) === JSON.stringify(block),
          );
          if (isMatchingBlock) {
            const convertToNum = Number(key);
            const incrementValue = Math.round(convertToNum + 1);
            const aHeadOfData =
              demoBlocks[next?.blockQuestNo][incrementValue]?.blockChoosen;
            setUpComingBlockChoosen(aHeadOfData);
          }
        }
      }

      if (!conditionTypes.includes(type)) {
        if (next?.blockShowNavigate) {
          if (next?.blockShowNavigate === 'Repeat Question') {
            const currentBlockinteraction =
              gameInfo?.blocks[currentQuest][currentBlock];

            setInteractionOptions(gameInfo, currentBlockinteraction);
            setType(next?.blockChoosen);
            setData(next);
            return false;
          } else if (next?.blockShowNavigate === 'New Block') {
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(next?.blockLeadTo)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];

                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);

              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);

                return false;
              } else {
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }

                return false;
              }
            }
          } else if (next?.blockShowNavigate === 'Replay Point') {
            setQuestState((prevquestdataList: any) => ({
              ...prevquestdataList,
              [parseInt(next?.blockQuestNo)]: 'replayallowed',
            }));
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            return false;
          } else if (next?.blockShowNavigate === 'Select Block') {
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(next?.blockLeadTo)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext && selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];

                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);

              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);

                return false;
              } else {
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }

                return false;
              }
            }
          } else if (next?.blockShowNavigate === 'Complete') {
            checkAndUpdateScores();
            checkCompletionBadge();
            fetchquestScore();
            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });
            } else {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                return data;
              });
            }
            setCurrentScreenId(6);
            setType(null);
            // setData(null);
            return false;
          } else {
            setType(demoBlocks[quest]['1']?.blockChoosen);
            setData(demoBlocks[quest]['1']);
            if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];
              for (const option of gameInfo.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1']?.blockPrimarySequence
                  ) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );

                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1'].blockPrimarySequence
                  ) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
            }
            return false;
          }
        } else {
          setType(demoBlocks[quest]['1']?.blockChoosen);
          setData(demoBlocks[quest]['1']);
          if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
            const optionsFiltered = [];
            for (const option of gameInfo.questOptions) {
              if (profileData?.Audiogetlanguage.length > 0) {
                if (
                  option?.qpSequence ===
                  demoBlocks[quest]['1']?.blockPrimarySequence
                ) {
                  const profilesetlan = profileData?.Audiogetlanguage.find(
                    (key: any) => key?.textId === option.qpOptionId,
                  );

                  if (profilesetlan) {
                    const languagecont = {
                      ...option,
                      qpOptionText: profilesetlan.content,
                    };
                    optionsFiltered.push(languagecont);
                  } else {
                    optionsFiltered.push(option);
                  }
                }
              } else {
                if (
                  option?.qpSequence ===
                  demoBlocks[quest]['1'].blockPrimarySequence
                ) {
                  optionsFiltered.push(option);
                }
              }
            }
            if (gameInfo?.gameData?.gameShuffle === 'true') {
              for (let i = optionsFiltered.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [optionsFiltered[i], optionsFiltered[j]] = [
                  optionsFiltered[j],
                  optionsFiltered[i],
                ];
              }
            }
            setOptions(optionsFiltered);
          }
          return false;
        }
      } else {
        if (type === 'Interaction' && resMsg !== '') {
          await forceStopAllAudio();
          setType('response');
          return false;
        } else if (
          (type === 'Interaction' || type === 'response') &&
          feed !== '' &&
          gameInfo?.interactionfeedback !== 'Completion'
        ) {
          if (navi === 'Replay Point') {
            setQuestState((prevquestdataList: any) => ({
              ...prevquestdataList,
              [parseInt(profile?.currentQuest)]: 'replayallowed',
            }));
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            return false;
          }
          if (navi === 'Replay Question') {
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
          } else {
            await forceStopAllAudio();
            setType('feedback');
            return false;
          }
        } else if (
          type === 'Interaction' ||
          type === 'response' ||
          type === 'feedback'
        ) {
          if (navi === 'Repeat Question') {
            setFeed('');
            setRepeatSelectOption(true);
            RepeatPrevOption.push(getSelectedOptions.options);
            setRepeatPrevOption(RepeatPrevOption);
            setType(next?.blockChoosen);
            setData(next);
            if (next?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];
              for (const option of gameInfo.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (option?.qpSequence === next?.blockPrimarySequence) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );
                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (option?.qpSequence === next?.blockPrimarySequence) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
            }
            return false;
          } else if (navi === 'Replay Question') {
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            // return false;
          } else if (navi === 'New Block') {
            setFeed('');
            setSelectedOption(null);
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(optionNavigation)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext && selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];
                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);
              // setSelectedOption(null);
              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }

                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);
                return false;
              } else {
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                return false;
              }
            }
          } else if (navi === 'Replay Point') {
            setQuestState((prevquestdataList: any) => ({
              ...prevquestdataList,
              [parseInt(profile?.currentQuest)]: 'replayallowed',
            }));
            setReplayState('replayPointPrompt');
            setReplayIsOpen(true);
            return false;
          } else if (navi === 'Select Block') {
            setFeed('');
            setSelectedOption(null);
            const selectedNext = Object.keys(demoBlocks[currentQuest])
              .filter((item: any) => {
                return (
                  demoBlocks[currentQuest][item]?.blockSecondaryId ===
                  parseInt(optionNavigation)
                );
              })
              .map((item: any) => {
                return demoBlocks[currentQuest][item];
              });
            if (selectedNext.length > 0) {
              setType(selectedNext && selectedNext[0]?.blockChoosen);
              if (selectedNext[0]?.blockChoosen === 'Interaction') {
                const optionsFiltered = [];
                for (const option of gameInfo.questOptions) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (
                      option?.qpSequence ===
                      selectedNext[0]?.blockPrimarySequence
                    ) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                if (gameInfo?.gameData?.gameShuffle === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ];
                  }
                }
                setOptions(optionsFiltered);
              }
              setData(selectedNext && selectedNext[0]);
              return false;
            } else {
              if (nextBlock[0] !== undefined) {
                setType(nextBlock[0]?.blockChoosen);
                if (nextBlock[0]?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        nextBlock[0]?.blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                setData(nextBlock[0]);
                return false;
              } else {
                setType(demoBlocks[quest]['1']?.blockChoosen);
                setData(demoBlocks[quest]['1']);
                if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
                  const optionsFiltered = [];
                  for (const option of gameInfo.questOptions) {
                    if (profileData?.Audiogetlanguage.length > 0) {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1']?.blockPrimarySequence
                      ) {
                        const profilesetlan =
                          profileData?.Audiogetlanguage.find(
                            (key: any) => key?.textId === option.qpOptionId,
                          );

                        if (profilesetlan) {
                          const languagecont = {
                            ...option,
                            qpOptionText: profilesetlan.content,
                          };
                          optionsFiltered.push(languagecont);
                        } else {
                          optionsFiltered.push(option);
                        }
                      }
                    } else {
                      if (
                        option?.qpSequence ===
                        demoBlocks[quest]['1'].blockPrimarySequence
                      ) {
                        optionsFiltered.push(option);
                      }
                    }
                  }
                  if (gameInfo?.gameData?.gameShuffle === 'true') {
                    for (let i = optionsFiltered.length - 1; i > 0; i--) {
                      const j = Math.floor(Math.random() * (i + 1));
                      [optionsFiltered[i], optionsFiltered[j]] = [
                        optionsFiltered[j],
                        optionsFiltered[i],
                      ];
                    }
                  }
                  setOptions(optionsFiltered);
                }
                return false;
              }
            }
          } else if (navi === 'Complete') {
            checkAndUpdateScores();
            checkCompletionBadge();
            setFeed('');
            const Nextcurrentquest = next?.blockQuestNo;
            const getgameinfoquest = gameInfo?.gameQuest.find(
              (row: any) => row.gameQuestNo == Nextcurrentquest,
            );
            if (demoBlocks.hasOwnProperty(nextLevel)) {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                if (!profile.completedLevels.includes(String(nextLevel))) {
                  data.completedLevels = [
                    ...data.completedLevels,
                    String(nextLevel),
                  ];
                }
                return data;
              });
            } else {
              setProfile((prev: any) => {
                const data = { ...prev };
                if (profile.compQuest.length === 0) {
                  data.compQuest = [String(profile?.currentQuest)];
                } else if (
                  !profile.compQuest.includes(String(profile?.currentQuest))
                ) {
                  data.compQuest = [
                    ...data.compQuest,
                    String(profile?.currentQuest),
                  ];
                }
                return data;
              });
            }
            setCurrentScreenId(6);
            setType(null);
            setData(null);
            return false;
          } else {
            setFeed('');
            setType(demoBlocks[quest]['1']?.blockChoosen);
            setData(demoBlocks[quest]['1']);
            if (demoBlocks[quest]['1']?.blockChoosen === 'Interaction') {
              const optionsFiltered = [];
              for (const option of gameInfo.questOptions) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1']?.blockPrimarySequence
                  ) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );

                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (
                    option?.qpSequence ===
                    demoBlocks[quest]['1'].blockPrimarySequence
                  ) {
                    optionsFiltered.push(option);
                  }
                }
              }
              if (gameInfo?.gameData?.gameShuffle === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ];
                }
              }
              setOptions(optionsFiltered);
            }
            return false;
          }
        }
      }
    }
    if (currentScreenId === 4) {
      LeaderBoardFunc(nextLevel);
    }
    if (currentScreenId === 6) {
      CompletionScreenFunction(nextLevel);
    }
    if (currentScreenId === 7) {
      setCurrentScreenId(13);
      return false;
    }
    if (currentScreenId === 8) {
      ReplayGameFunc();
    }
    if (currentScreenId === 14) {
      AfterCompletionFeedBackFunc();
    }
    
  };

  const getData = async (next: any) => {
  if (nextLockRef.current) return false;   // repeated click -> ignore

  nextLockRef.current = true;
  setIsNextLoading(true);
  pendingMoveRef.current = [];

  let result: any;

  try {
    // 1) Original logic: activityUpdate + createGamePlayHistory run once.
    //    The screen-moving setters are only collected, not applied.
    result = await getDataCore(next);

    // 2) Let React commit the other state changes so the save has fresh data
    await sleep(50);

    // 3) If an autosave is running, wait for it to finish
    while (learnerUpdateInProgressRef.current) {
      await sleep(50);
    }

    // 4) Save (updateLearnerDetails), retry up to 3 times on failure
    let saved = false;
    for (let attempt = 1; attempt <= 3 && !saved; attempt++) {
      lastSaveOkRef.current = false;
      await UpdateLearnerDataSafe();
      saved = lastSaveOkRef.current;

      if (!saved) {
        if (saveFatalRef.current) break;   // assignment error, retrying won't help
        if (attempt < 3) await sleep(1000);
      }
    }

    // 5) Move to the next block only if the save succeeded
    if (saved) {
      const moves = pendingMoveRef.current;
      pendingMoveRef.current = [];
      moves.forEach((fn) => fn());
    } else {
      pendingMoveRef.current = [];         // discard: learner stays on this block
      console.error("updateLearnerDetails failed, not moving to next block");
      // optional: show a toast/alert here, e.g. "Could not save, please try again"
    }
  } catch (error) {
    pendingMoveRef.current = [];
    console.error("getData failed:", error);
  } finally {
    // Keep the lock a little longer so the useEffect runs caused by the
    // block change are still skipped
    setTimeout(() => {
      nextLockRef.current = false;
      setIsNextLoading(false);
    }, 300);
  }

  return result;
};

//   const getData = async (next: any) => {
//   // A Next click is already running -> ignore this click
//   if (nextLockRef.current) return false;

//   nextLockRef.current = true;
//   setIsNextLoading(true);
//     pendingMoveRef.current = [];

//   let result: any;

//   try {
//     // 1) Your original logic (activityUpdate + createGamePlayHistory run once)
//     result = await getDataCore(next);

//     // 2) Wait so React commits the state changes made inside getDataCore,
//     //    so latestLearnerDataRef.current holds the fresh data
//     await new Promise((resolve) => setTimeout(resolve, 50));

//     // 3) updateLearnerDetails runs once
//     await UpdateLearnerDataSafe();
//   } catch (error) {
//     console.error("getData failed:", error);
//   } finally {
//     // Release after a short delay so the useEffect runs triggered by this
//     // click are still skipped, and fast repeated clicks are ignored
//     setTimeout(() => {
//       nextLockRef.current = false;
//       setIsNextLoading(false);
//     }, 300);
//   }

//   // Same return value as before, so existing callers behave the same
//   return result;
// };

  // kishore new overallquest completion logic
  const handleQuestScore = async () => {
    const data = {
      learnerId: gameInfo?.learnerDetails?.lenId,
      gameId: gameInfo?.gameId,
    };

    const AllQuest = await AllQestSingleScore(JSON.stringify(data));

    setAllQuestScore(AllQuest?.Data);
  };

  useEffect(() => {
    if (
      learner_game_play_id &&
      Number(currentScreenId) === 21 &&
      !isQuestCalled
    ) {
      handleQuestScore();
      setIsQuestCalled(true);
    }

    if (Number(currentScreenId) !== 21) {
      setIsQuestCalled(false);
    }

    if (allQuestScores) {
      // your existing logic
    }
  }, [learner_game_play_id, currentScreenId, isQuestCalled]);

  // useEffect(() => {

  //   if (learner_game_play_id && currentScreenId === 21) {

  //     handleQuestScore();
  //   }

  //   if (allQuestScores) {

  //   }
  // }, [learner_game_play_id, currentScreenId]);

  const currentScenarioRef = useRef(null);

  const fetchScenarioChange = async () => {
    const response = await ScenarioChange(learner_game_play_id);

    const scenarios = response?.scenarios || [];
    setScenarioNpcs(scenarios);

    const currentBlockId = data?.blockId;
    if (!currentBlockId) return;

    const questBlocks = demoBlocks?.[data?.blockQuestNo];

    const blocksArray = Object.values(questBlocks || {}) as Block[];

    const matchedBlock = blocksArray.find(
      (block) => block.blockId === currentBlockId,
    );

    if (!matchedBlock?.blockScenario) {
      setScenarioChange(false);
      return;
    }

    const nextScenario = matchedBlock.blockScenario;

    // 🔑 FIRST LOAD (no transition)
    if (currentScenarioRef.current === null) {
      currentScenarioRef.current = nextScenario;
      setScenarioChange(false);
      return;
    }

    const isScenarioChanged = currentScenarioRef.current !== nextScenario;

    if (isScenarioChanged) {
      setScenarioChange(true);
      currentScenarioRef.current = nextScenario; // lock it
    } else {
      setScenarioChange(false);
    }
  };
  useEffect(() => {
    fetchScenarioChange();
  }, [data?.blockScenario]);
  // useEffect(() => {
  //   fetchScenarioChange();
  // }, [data?.blockId]);

  const calScore = () => {
    const currentQuest = profile?.currentQuest || '1';
    const currentGameData = gameInfo.gameQuest.find(
      (row: any) => row.gameQuestNo == profile?.currentQuest,
    );
    const nextLevel = parseInt(profile?.currentQuest) + 1 || null;
    const haveNextQuest = gameInfo.gameQuest.some(
      (row: any) => row.gameQuestNo > profile.currentQuest,
    );
    let totalScore = 0;
    profile?.score.reduce((acc: any, row: any) => {
      if (row.quest === profile?.currentQuest) {
        return acc + row.score;
      }
      return acc;
    }, 0);
    return {
      currentQuest: currentQuest,
      currentGameData: currentGameData,
      nextLevel: nextLevel,
      haveNextQuest: haveNextQuest,
      totalScore: totalScore,
    };
  };

  const handleValidate = (item: any, ind: any) => {
    const optionAudioFiltered = profileData?.Audiogetlanguage.filter(
      (key: any) => key?.textId === item?.qpOptionId,
    );
    if (optionAudioFiltered.length > 0) {
      const responseFiltered = optionAudioFiltered.filter(
        (key: any) => key?.fieldName === 'qpResponse',
      );
      const FeedFiltered = optionAudioFiltered.filter(
        (key: any) => key?.fieldName === 'qpFeedback',
      );
      if (responseFiltered.length > 0) {
        const FilteredResponsecontent = responseFiltered[0]?.content;
        const resMsgLanguage = FilteredResponsecontent;
        setResMsg(resMsgLanguage);
      } else {
        setResMsg(item?.qpResponse);
      }
      if (FeedFiltered.length > 0) {
        const FilteredFeedcontent = FeedFiltered[0]?.content;
        const feedMsgLanguage = FilteredFeedcontent;
        setFeed(feedMsgLanguage);
      } else {
        setFeed(item?.qpFeedback);
      }
    } else {
      setResMsg(item?.qpResponse);
      setFeed(item?.qpFeedback);
    }

    setNavi(item?.qpNavigateShow);
    setOptionNavigation(item?.qpNextOption);
    setSelectedOption(item?.qpOptions);
    SetgetSelectedOptions({
      options: item.qpOptions,
      optionText: item.qpOptionText,
      qpFeedback: item.qpFeedback,
      interactionfeedback: item.interactionfeedback,
    });
    setGameInfo((prev: any) => ({
      ...prev,
      interactionfeedback: item.interactionfeedback,
    }));
    setOptionSelectId(item.qpOptionId);
  };

  useEffect(() => {
    if (voiceRef.current) {
      voiceRef.current.pause();
    }
    const backGroundBgmscreens = [1, 12, 13];
    if (
      ![2, 3, 4, 5, 6, 7, 0, 14].includes(currentScreenId) &&
      backGroundBgmscreens.includes(currentScreenId)
    ) {
      setAudioObj((prev) => ({
        ...prev,
        url: audio,
        type: EnumType.BGM,
        loop: false,
        autoplay: true,
      }));
      if (
        backgroundBgmRef.current &&
        ![2, 3, 4, 5, 6, 7, 0, 14].includes(currentScreenId) &&
        backGroundBgmscreens.includes(currentScreenId)
      ) {
        try {
          backgroundBgmRef.current.play().catch((error) => {});
        } catch (error) {
          console.error('Background BGM ref is not available.', error);
        }
      }
      if (voiceRef.current) {
        voiceRef.current.pause();
      }
    }
    if (currentScreenId === 2 && isLoading === true) {
      if (backgroundBgmRef.current) {
        backgroundBgmRef.current.pause();
      }
      if (voiceRef.current) {
        try {
          voiceRef?.current?.play().catch((error) => {});
        } catch (error) {
          console.error('Background BGM ref is not available.', error);
        }
      }
    }
    const screens = [10, 8, 14, 0, 6, 4];

    if (currentScreenId !== 4) {
      setHomeLeaderBoard(null);
    }
  }, [currentScreenId]);
  useEffect(() => {
    if (audioRef.current) {
      if (currentScreenId === 2) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
  }, [currentScreenId]);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const startDemo = () => {
    onClose1();
    setCurrentScreenId(10);
  };

  const replayGame = () => {
    setType(gameInfo?.blocks[profile?.currentQuest]['1']?.blockChoosen);
    setData(gameInfo?.blocks[profile?.currentQuest]['1']);
    setCurrentScreenId(2);
  };
  const replayNextHandler = () => {
    const nextLevel = parseInt(profile?.currentQuest) + 1 || null;
    if (demoBlocks.hasOwnProperty(nextLevel)) {
      setProfile((prev: any) => {
        const data = { ...prev };
        if (!profile.completedLevels.includes(String(nextLevel))) {
          data.completedLevels = [...data.completedLevels, String(nextLevel)];
        }
        return data;
      });
      setType(demoBlocks[nextLevel]['1']?.blockChoosen);
      setData(demoBlocks[nextLevel]['1']);
      setMotionEffect(true);
      setCurrentScreenId(13);
      // setCurrentScreenId(6);
      return false;
    } else {
      if (
        gameInfo.gameData?.gameIsShowReflectionScreen !== 'false' &&
        gameInfo?.reflectionQuestions.length > 0
      ) {
        setCurrentScreenId(3); //Navigate to Reflection screen
        return false;
      } else if (gameInfo.gameData?.gameIsShowTakeaway !== 'false') {
        setCurrentScreenId(7); //Navigate to Takeaway screen
        return false;
      } else {
        setType(null);
        setData(null);
        setCurrentScreenId(13); //Navigate to Thank you screen
        return false;
      }
    }
  };

  useEffect(() => {
    const fetchSupportedLanguages = async () => {
      if (gameInfo?.gameData?.gameId > 0) {
        const resLang = await getGameLanguages(gameInfo?.gameData?.gameId);
        setLoadingProgress(60);
        if (resLang?.status === 'Success') {
          if (resLang?.data.length > 0) {
            const data = resLang?.data;
            const ifEnglishExist = data.filter((lang: any) => lang.value === 1);
            if (ifEnglishExist.length === 0) {
              data.unshift({ value: 1, label: 'English' });
            }
            setGameLanguages(data);
            setHasMulitLanguages(true);
          } else {
            setGameLanguages([{ value: 1, label: 'English' }]);
            setProfileData((prev: any) => ({
              ...prev,
              language: 1,
            }));
            setLearnerPlayingDetails((prev: any) => ({
              ...prev,
              LearnerProfile: {
                ...prev.LearnerProfile,
                language: 1,
              },
            }));
            setHasMulitLanguages(true);
          }
        }
      }
    };

    const startTimer = () => {
      timeRef.current = window.setInterval(() => {
        setSeconds((prevSeconds: any) => prevSeconds + 1);
      }, 1000);
    };

    const stopTimer = () => {
      if (timeRef.current !== null) {
        clearInterval(timeRef.current);
        timeRef.current = null;
      }
    };

    const handleVisibilityTabChange = () => {
      if (document.visibilityState === 'hidden') {
        stopTimer();
      } else if (document.visibilityState === 'visible') {
        startTimer();
      }
    };

    fetchSupportedLanguages();
    startTimer();

    document.addEventListener('visibilitychange', handleVisibilityTabChange);

    return () => {
      document.removeEventListener(
        'visibilitychange',
        handleVisibilityTabChange,
      );
      stopTimer();
    };
  }, []);

  const getCurrentResolution = () => {
    const body = document.getElementById('body');
    body.style.width = `${window.innerWidth}px`;
    body.style.height = `${window.innerHeight}px`;

    return body;
  };

  const dontShowTopMenu = ![3, 4, 5, 6, 7, 10, 16, 17].includes(
    currentScreenId,
  );
  useEffect(() => {
    if (FeedbackNavigatenext === true) {
      setisScreenshot(false);
      getData(data);
    }
  }, [FeedbackNavigatenext]);

  const getFeedbackData = (data?: any) => {
    // setisScreenshot(true);
    const groupedFeedback: { [key: string]: any[] } = {};
    feedbackList?.forEach((feedback:any) => {
      if (!(feedback.Seq in groupedFeedback)) {
        groupedFeedback[feedback.Seq] = [];
      }
      const existingFeedback = groupedFeedback[feedback.Seq].find(
        (f) =>
          f.Options.options === feedback.Options.options &&
          f.type === feedback.type,
      );
      if (!existingFeedback) {
        groupedFeedback[feedback.Seq].push(feedback);
      }
    });

    const firstPageFeedback: any[] = [];
    Object.keys(groupedFeedback).forEach((seq: any) => {
      groupedFeedback[seq].forEach((feedback) => {
        if (profile.currentQuest == feedback.quest) {
          firstPageFeedback.push(feedback);
        }
      });
    });

    let newRemainingSentences: any;
    let ScreenShotScore: any;
    if (
      firstPageFeedback.length !== 0 &&
      FeedbackcurrentPosition < firstPageFeedback.length
    ) {
      newRemainingSentences =
        firstPageFeedback[FeedbackcurrentPosition].feedbackcontent;
      ScreenShotScore = firstPageFeedback[FeedbackcurrentPosition].totalPoints;
      const getgameinfoblockchoosen = gameInfo?.blocks[profile?.currentQuest];
      const getArray = [];
      for (const key in getgameinfoblockchoosen) {
        if (getgameinfoblockchoosen[key].blockChoosen === 'Interaction') {
          getArray.push(getgameinfoblockchoosen[key]);
        }
      }

      const GetSeqData = getArray.filter((item: any) => {
        return (
          item?.blockPrimarySequence ===
          firstPageFeedback[FeedbackcurrentPosition].Seq
        );
      });
      const optionsFiltered: any = [];
      for (const option of gameInfo.questOptions) {
        if (profileData?.Audiogetlanguage.length > 0) {
          if (option?.qpSequence === GetSeqData[0]?.blockPrimarySequence) {
            const profilesetlan = profileData?.Audiogetlanguage.find(
              (key: any) => key?.textId === option.qpOptionId,
            );

            if (profilesetlan) {
              const languagecont = {
                ...option,
                qpOptionText: profilesetlan.content,
              };
              optionsFiltered.push(languagecont);
            } else {
              optionsFiltered.push(option);
            }
          }
        } else {
          if (option?.qpSequence === GetSeqData[0]?.blockPrimarySequence) {
            optionsFiltered.push(option);
          }
        }
      }

      const SelectedoptionsFiltered = optionsFiltered.filter(
        (key: any) =>
          key?.qpOptions ==
          firstPageFeedback[FeedbackcurrentPosition].Options['options'],
      );
      const selectoptionfeed = SelectedoptionsFiltered[0].qpOptions
        ? SelectedoptionsFiltered[0].qpOptions
        : 'null';
      startTransition(() => {
        setInterActionBlockArray(firstPageFeedback.length);
        setOptions(optionsFiltered);
        setFeedBackSelectedoptionData(selectoptionfeed);
        setFeedBackoptionData(GetSeqData);
        setFeedbackCurrentPosition(FeedbackcurrentPosition + 1);
        setFeedbackRemainingSentences(newRemainingSentences);
        setInterActionScore(ScreenShotScore);
      });
    } else {
      startTransition(() => {
        setInterActionBlockArray(0);
        setOptions(null);
        setFeedBackSelectedoptionData(null);
        setFeedBackoptionData(null);
        setFeedbackCurrentPosition(0);
        setFeedbackRemainingSentences(null);
        setFeedbackNavigateNext(true);
        setInterActionScore(null);
      });
    }
  };
  function TriggerAnimation(data: () => void) {
    setMotionEffect(true);
    setTimeout(() => {
      data();
    }, 300);
  }

  const currentQuestRef = useRef(profile?.currentQuest);

  useEffect(() => {
    currentQuestRef.current = profile?.currentQuest;
  }, [profile?.currentQuest]);

  const [scenariowisebestscore1, setscenariowisebestscore1] = useState<
    number | null
  >(null);
  const [sceneriowiseEarnedScore, setSceneriowiseEarnedScore] = useState<
    number | null
  >(null);
  const [sceneriowiseHighestEarnedScore, setSceneriowiseHighestEarnedScore] =
    useState<number | null>(null);
  const [scenarioTotalScore, setScenarioTotalScore] = useState<number | null>(
    null,
  );
  const [scenarioMinScore, setScenarioMinScore] = useState<number | null>(null);
  const [scenarioDistinctionScore, setScenarioDistinctionScore] = useState<
    number | null
  >(null);
  const [scenarioAllTimeScore, setScenarioAllTimeScore] = useState([]);
  const [scenarioReplay, setScenarioReplay] = useState(false);


  useEffect(() => {
   
    setLearnerPlayingDetails((prev: any) => ({
          ...prev,
          currentReplayInfo:currentReplayInfo,
    }));
    
  }, [currentReplayInfo]);
  const handleScenarioReplayButtonClick = async (
    replayType: 'mandatoryReplay' | 'optionalReplay' | 'replayPointPrompt',
    scenarioId: string | number,
  ) => {
    setCurrentReplayInfo({
      scenarioName: scenarioId, // or get actual name from your data
      replayType: replayType,
      questNo: parseInt(profile.currentQuest),
    });
    setScenarioReplay(true);
    setShowScenarioLeaderboard(false);
    /* ---------------- NORMALIZE SCENARIO ---------------- */
    const normalizedScenarioId =
      typeof scenarioId === 'string'
        ? parseInt(scenarioId.replace(/\D/g, ''), 10)
        : scenarioId;

    const normalizedScenarioName =
      typeof scenarioId === 'number' ? `Scenario ${scenarioId}` : scenarioId;

    const currentQuestNo = parseInt(profile.currentQuest);

    /* ====================================================
       LOCAL STORAGE — GAME WISE SCENARIO SCORES
    ==================================================== */

    // const allScores: Record<string, Record<string, number>> = JSON.parse(
    //   localStorage.getItem('scenarioScores') || '{}',
    // );

    const gameId = String(learner_game_play_id);
    const scenarioKey = String(normalizedScenarioId);

    // const gameScores: Record<string, number> = allScores[gameId] || {};

    // /* ---------------- REMOVE CURRENT SCENARIO ---------------- */
    // if (gameScores[scenarioKey] !== undefined) {
    //   delete gameScores[scenarioKey];
    // }

    // allScores[gameId] = gameScores;

    // localStorage.setItem('scenarioScores', JSON.stringify(allScores));

    // /* ---------------- CALCULATE TOTAL SCORE (CURRENT GAME ONLY) ---------------- */
    // const totalScenarioScore = Object.values(gameScores)
    //   .map(Number)
    //   .reduce((sum, val) => sum + val, 0);
    const getallScores: Record<string, Record<string, number>> = gameProgressData?.scenarioScores || {};

    const getgamequestScores: Record<string, number> = getallScores[parseInt(profile.currentQuest)] || {};

    /* ---------------- REMOVE CURRENT SCENARIO ---------------- */
    if (getgamequestScores[scenarioKey] !== undefined) {
      delete getgamequestScores[scenarioKey];
    }

    getallScores[parseInt(profile.currentQuest)] = getgamequestScores;

    setGameProgressData((prev: any) => ({
      ...prev,
      scenarioScores: getallScores,
    }));
    /* ---------------- CALCULATE TOTAL SCORE (CURRENT GAME ONLY) ---------------- */
    const totalScenarioScore = Object.values(getgamequestScores)
      .map(Number)
      .reduce((sum, val) => sum + val, 0);
    /* ====================================================
       RESET UI STATES
    ==================================================== */

    setFeed('');
    setRepeatPrevOption(null);
    setOptions(null);
    setSelectedOption(null);
    setFeedBackSelectedoptionData(null);
    setFeedBackoptionData(null);
    setprevBlock([]);

    const updatedFeedbackList =
      feedbackList?.filter(
        (f: any) =>
          f.quest !== currentQuestNo || f.scenario !== normalizedScenarioId,
      ) || [];

    setFeedbackList(updatedFeedbackList);

    /* ====================================================
       UPDATE PROFILE SCORES
    ==================================================== */

    const updatedScore = [
      ...(profile?.score ?? []).filter((s: any) => {
        return !(
          Number(s.quest) === Number(currentQuestNo) &&
          Number(s.scenarioId) === Number(normalizedScenarioId)
        );
      }),
      {
        quest: currentQuestNo,
        score: totalScenarioScore,
      },
    ];

    // const updatedReplayScore = [
    //   ...(profile?.replayScore || []).filter(
    //     (s: any) => s.quest !== currentQuestNo,
    //   ),
    //   {
    //     quest: currentQuestNo,
    //     score: totalScenarioScore,
    //   },
    // ];
    const updatedReplayScore = [
  ...(profile?.replayScore || []).filter((s: any) => {
    return !(
      Number(s.quest) === Number(currentQuestNo) &&
      Number(s.scenarioId) === Number(normalizedScenarioId)
    );
  }),
  {
    quest: currentQuestNo,
    scenarioId: normalizedScenarioId,
    score: totalScenarioScore,
  },
];

    setProfile((prev: any) => ({
      ...prev,
      score: updatedScore,
      replayScore: updatedReplayScore,
      questNo: prev.currentQuest,
      currentScenario: normalizedScenarioId,
      currentBlockIndex: 0,
    }));



    const questBlocks = demoBlocks?.[currentQuestNo];
    if (!questBlocks) return;

    const scenarioBlocks = Object.values(questBlocks).filter(
      (block: any) => block.blockScenario === normalizedScenarioName,
    );

    if (!scenarioBlocks.length) return;

    scenarioBlocks.sort(
      (a: any, b: any) =>
        Number(a.blockSecondaryId) - Number(b.blockSecondaryId),
    );

    const firstBlock: any = scenarioBlocks[0];

    setType(firstBlock.blockChoosen);
    setData(firstBlock);
    setSelectedOption([]);

    if (firstBlock.blockChoosen === 'Interaction') {
      let optionsFiltered: any[] = [];

      for (const option of gameInfo.questOptions) {
        if (option.qpSequence === firstBlock.blockPrimarySequence) {
          const translated = profileData?.Audiogetlanguage?.find(
            (k: any) => k.textId === option.qpOptionId,
          );

          optionsFiltered.push(
            translated
              ? { ...option, qpOptionText: translated.content }
              : option,
          );
        }
      }

      if (gameInfo?.gameData?.gameShuffle === 'true') {
        optionsFiltered.sort(() => Math.random() - 0.5);
      }

      setOptions(optionsFiltered);
    }

    setCurrentScreenId(2);
    setScenarioReplay(false);
 const createReplayActivity = async () => {
      const createRes = await activityCreate(
        JSON.stringify({
          gameId: learner_game_play_id,
          scenario: normalizedScenarioId,
          galBlockId: firstBlock?.blockSecondaryId,
          galblockleft:firstBlock?.blockSecondaryId,
          averageScore: totalScenarioScore,
          galAssignedId: AssignId,
          questNo: profile.currentQuest,
        })
      );

      if (createRes?.status === 'Success') {
        setActivitydata(createRes.data);
      }
    };

    if (
      replayType === 'mandatoryReplay' ||
      replayType === 'replayPointPrompt' ||
      replayType === 'optionalReplay'
    ) {
      createReplayActivity();
    }
  };

  const handleReplayButtonClick = async (replayType: string) => {
    const getprogressallScores = {
      ...(gameProgressData?.scenarioScores || {})
    };
    const currentQuest = parseInt(profile?.currentQuest);
    if(getprogressallScores[currentQuest]!== undefined){
      // remove current quest scores
      delete getprogressallScores[currentQuest];
    }
    // update state
    setGameProgressData((prev: any) => ({
      ...prev,
      scenarioScores: getprogressallScores,
    }));
   
    const updatedFeedbackList =
      feedbackList &&
      feedbackList?.filter(
        (feedback:any) => feedback.quest != profile.currentQuest,
      );
    setFeedbackList(updatedFeedbackList);
    if (replayState === 'replayPointprompt') {
      setFeed('');
      setOptions(null);
      setFeedBackSelectedoptionData(null);
      setFeedBackoptionData(null);
    }

    if (replayType === 'mandatoryReplay') {
      let updatedscore: any = profile?.score?.filter(
        (item: any) => item.quest !== parseInt(profile?.currentQuest),
      );

      if (questState[parseInt(profile?.currentQuest)] === 'completed') {
        setQuestState((prevquestdataList: any) => ({
          ...prevquestdataList,
          [parseInt(profile?.currentQuest)]: 'Started',
        }));
      }
      setProfile((prev: any) => ({
        ...prev,
        score:
          questState[parseInt(profile?.currentQuest)] === 'Started' ||
          questState[parseInt(profile?.currentQuest)] === 'completed'
            ? updatedscore
            : prev.score,
        // replayScore:questState[parseInt(profile?.currentQuest)] === 'replayallowed' ? updatedscore : prev.replayScore,
      }));
      if (learnerPlayList.Prevquestseq[profile.currentQuest]) {
        setLearnerPlayingDetails((prev: any) => {
          const updatedPrevquestseq = { ...prev.Prevquestseq };
          if (updatedPrevquestseq[profile.currentQuest]) {
            delete updatedPrevquestseq[profile.currentQuest];
          }
          return {
            ...prev,
            Prevquestseq: updatedPrevquestseq,
          };
        });
        setprevBlock([]);
      }
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      const data1 = {
        blockname: type,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft:data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: formatTime(seconds),
        galAssignedId:AssignId,
        navigateId: !conditionTypes.includes(type)
          ? data?.blockShowNavigate
          : navi,
      };
      const actId1 = Activitydata;
      const datas = JSON.stringify(data1);
      const result = await activityUpdate(datas, actId1);
      setLoadingProgress(15);
      if (result.status !== 'Success') {
        return false;
      }
    }
    if (replayType === 'replayPointPrompt') {
      if (navi === 'Replay Question') {
        // getData(data);

        setFeed('');

        // setRepeatPrevOption([]);
        RepeatPrevOption.push(getSelectedOptions.options);
        setRepeatPrevOption(RepeatPrevOption);
        setRepeatSelectOption(true);
        // setReplayQuesShow(true);
        setType(data?.blockChoosen);
        setData(data);

        if (data?.blockChoosen === 'Interaction') {
          const optionsFiltered = [];

          for (const option of gameInfo.questOptions) {
            if (option?.qpSequence === data?.blockPrimarySequence) {
              if (profileData?.Audiogetlanguage.length > 0) {
                const profilesetlan = profileData.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );
                optionsFiltered.push(
                  profilesetlan
                    ? { ...option, qpOptionText: profilesetlan.content }
                    : option,
                );
              } else {
                optionsFiltered.push(option);
              }
            }
          }

          if (gameInfo?.gameData?.gameShuffle === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ];
            }
          }

          setOptions(optionsFiltered);
        }
        return;
      }
      setFeed('');
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        updatedscore = profile?.score?.filter(
          (item: any) => item.quest !== parseInt(profile?.currentQuest),
        );
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        updatedscore = profile?.replayScore.filter(
          (item: any) => item.quest !== parseInt(profile?.currentQuest),
        );
      }

      setProfile((prev: any) => ({
        ...prev,
        score:
          questState[parseInt(profile?.currentQuest)] === 'Started'
            ? updatedscore
            : prev.score,
        replayScore:
          questState[parseInt(profile?.currentQuest)] === 'replayallowed'
            ? updatedscore
            : prev.replayScore,
      }));
      if (learnerPlayList.Prevquestseq[profile.currentQuest]) {
        setLearnerPlayingDetails((prev: any) => {
          const updatedPrevquestseq = { ...prev.Prevquestseq };
          if (updatedPrevquestseq[profile.currentQuest]) {
            delete updatedPrevquestseq[profile.currentQuest];
          }
          return {
            ...prev,
            Prevquestseq: updatedPrevquestseq,
          };
        });
        setprevBlock([]);
      }
      let total = 0;
      const scoreArray = updatedscore;
      if (scoreArray?.length > 0) {
        total = scoreArray?.reduce((acc: number, cur: any) => {
          if (cur.quest === parseInt(profile?.currentQuest)) {
            return acc + cur.score;
          } else {
            return acc;
          }
        }, 0);
      }
      const conditionTypes = ['Interaction', 'response', 'feedback'];
      const data1 = {
        blockname: type,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft:data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: formatTime(seconds),
        galAssignedId:AssignId,
        navigateId: !conditionTypes.includes(type)
          ? data?.blockShowNavigate
          : navi,
      };
      // const actId1 = Activitydata;
      setProfile((prev: any) => ({
        ...prev,
        currentQuest: prev.currentQuest, // fallback to old value
      }));

      const checkdata = {
        gameId: learner_game_play_id,
        questNo: profile.currentQuest,
      };

      const datas1 = JSON.stringify(checkdata);

      const lastBlockresult = await activitygetlastblock(datas1);
      setLoadingProgress(40);

      setActivitydata(lastBlockresult?.data[0]?.galId);
      const actId1 = lastBlockresult?.data[0]?.galId;
      const datas = JSON.stringify(data1);
      const result = await activityUpdate(datas, actId1);
      setLoadingProgress(20);
      if (result.status !== 'Success') {
        return false;
      }
    }
    if (replayType === 'optionalReplay') {
      setFeed('');
      let updatedscore: any = profile?.score?.filter(
        (item: any) => item.quest !== parseInt(currentQuestRef.current),
      );

      setProfile((prev: any) => ({
        ...prev,
        score:
          questState[parseInt(currentQuestRef.current)] === 'Started'
            ? updatedscore
            : prev.score,
        // replayScore:questState[parseInt(profile?.currentQuest)] === 'replayallowed' ? updatedscore : prev.replayScore,
      }));
      if (learnerPlayList.Prevquestseq[currentQuestRef.current]) {
        setLearnerPlayingDetails((prev: any) => {
          const updatedPrevquestseq = { ...prev.Prevquestseq };
          if (updatedPrevquestseq[currentQuestRef.current]) {
            delete updatedPrevquestseq[currentQuestRef.current];
          }
          return {
            ...prev,
            Prevquestseq: updatedPrevquestseq,
          };
        });
        setprevBlock([]);
      }
      const data = {
        gameId: learner_game_play_id,
        questNo: parseInt(currentQuestRef.current),
        galBlockId: demoBlocks[currentQuestRef.current]['1']?.blockSecondaryId,
        galblockleft:demoBlocks[currentQuestRef.current]['1']?.blockSecondaryId,
        averageScore: 0,
        galAssignedId: AssignId,
      };
      const datas = JSON.stringify(data);
      const result = await activityCreate(datas);
      setLoadingProgress(25);
      if (result.status !== 'Success') {
        return false;
      }
      setActivitydata(result?.data);
    }
    setType(demoBlocks[currentQuestRef.current]['1']?.blockChoosen);
    setData(demoBlocks[currentQuestRef.current]['1']);
    if (
      demoBlocks[currentQuestRef.current]['1']?.blockChoosen === 'Interaction'
    ) {
      const optionsFiltered = [];
      for (const option of gameInfo.questOptions) {
        if (profileData?.Audiogetlanguage.length > 0) {
          if (
            option?.qpSequence ===
            demoBlocks[currentQuestRef.current]['1']?.blockPrimarySequence
          ) {
            const profilesetlan = profileData?.Audiogetlanguage.find(
              (key: any) => key?.textId === option.qpOptionId,
            );

            if (profilesetlan) {
              const languagecont = {
                ...option,
                qpOptionText: profilesetlan.content,
              };
              optionsFiltered.push(languagecont);
            } else {
              optionsFiltered.push(option);
            }
          }
        } else {
          if (
            option?.qpSequence ===
            demoBlocks[currentQuestRef.current]['1']?.blockPrimarySequence
          ) {
            optionsFiltered.push(option);
          }
        }
      }
      if (gameInfo?.gameData?.gameShuffle === 'true') {
        for (let i = optionsFiltered.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [optionsFiltered[i], optionsFiltered[j]] = [
            optionsFiltered[j],
            optionsFiltered[i],
          ];
        }
      }
      setOptions(optionsFiltered);
    }
    setCurrentScreenId(2);
  };

  //new by kaviya
  const audioCtxRef = useRef<AudioContext | null>(null);


  function playMenuAndNext(ctx: AudioContext) {
    const now = ctx.currentTime;
    [520, 780].forEach((freq, i) => {
      const t = now + i * 0.06;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, t);
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.15, t + 0.005);
      gain.gain.linearRampToValueAtTime(0, t + 0.05);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.06);
    });
  }
  function getAudioContext() {
    if (!audioCtxRef.current) {
      audioCtxRef.current = new (window.AudioContext ||
        (window as any).webkitAudioContext)();
    }
    if (audioCtxRef.current.state === 'suspended') {
      audioCtxRef.current.resume();
    }
    return audioCtxRef.current;
  }

  function playMenuSound() {
    const ctx = getAudioContext();
    playMenuAndNext(ctx);
  }

  useEffect(() => {
    setTimeout(() => {
      setMotionEffect(false);
    }, 100);
  }, [currentScreenId, replayIsOpen]);

  const parseSequence = (seq: any) => {
    return seq.split('.').map(Number);
  };


  useEffect(() => {
    if (!(gameInfo?.reviewer?.ReviewerId || user?.data?.id)) {
      setIsAuthFailed({
        status: true,
        authMsg: 'Your session has timed out. Please login then try again',
        reviewStatus: false,
      });
    }
  }, [gameInfo?.reviewer?.ReviewerId, user?.data?.id]);



  useEffect(() => {}, [GlbPlayindDetails]);

  const questIndex = Number(currentQuestRef?.current) - 1;

  const activeQuestBgName =
    gameInfo?.assets?.questBackgrounds?.[questIndex]?.bgName;

  const [reportData, setReportData] = useState<any>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [htmlString, setHtmlString] = useState<string>('');

  const reportFetchData = async () => {
    try {
      setLoading(true);
      //kishore report

      const datas = {
        gameId: gameInfo?.gameId,
        learnerid: gameInfo?.learnerDetails?.lenId,
      };

      // const res = await gamereport(JSON.stringify(payload));

      const res = await gamereport(JSON.stringify(datas));

      const data = res?.Data;
      setReportData(data);
      // setReportData(res.Data);
      if (data) {
        const html = await generateReportHTML(
          data,
          sampleLearnerData,
          checklistData,
          takeawaysData,
        );
        setHtmlString(html);
      }
    } catch (error) {
      console.error('Fetch Error:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (learner_game_play_id) {
      reportFetchData();
    }
  }, [learner_game_play_id]);

  const handleAssessmentComplete = async (metrics: any) => {
    const updated = {
      ...learnerPlayList,
      Assessment:
        learnerPlayList.Assessment?.length > 0
          ? [metrics] // 🔥 replace existing object
          : [metrics], // first time create it
    };

    setLearnerPlayingDetails(updated);

    await updateLearnerDetails(
      JSON.stringify({
        learnerPlayList: updated,
      }),
    );
  };

  return (
    <ProfileContext.Provider value={{ profileData, setMotionEffect }}>
      {isAuthFailed.status === false ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: motionEffect ? 0 : 1 }}
        >
          <LoadingOverlay isVisible={isFetching} text="Loading..." primaryColor={primaryColor} />
          {gameInfo?.gameData?.gameTheme === 'false' ? (
            <TopMenuBar
              isLeaderboardEnabled={isLeaderboardEnabled}
              setIsLeaderboardEnabled={setIsLeaderboardEnabled}
              dontShowTopMenu={dontShowTopMenu}
              preloadedAssets={preloadedAssets}
              currentScreenId={currentScreenId}
              setCurrentScreenId={setCurrentScreenId}
              isSettingOpen={isSettingOpen}
              setIsSettingOpen={setIsSettingOpen}
              setHomeLeaderBoard={setHomeLeaderBoard}
              profileData={profileData}
              gameInfo={gameInfo}
              demoBlocks={demoBlocks}
              data={data}
              setAudioObj={setAudioObj}
              audioObj={audioObj}
              questState={questState}
              EnumType={EnumType}
              setLearnerPlayingDetails={setLearnerPlayingDetails}
              learnerPlayList={learnerPlayList}
              handleMusicVolume={handleMusicVolume}
              homeLeaderBoard={homeLeaderBoard}
              formData={gameInfo?.gameData}
              imageSrc={preloadedAssets.Lead}
              getData={getData}
              setPlayerTodayScore={setPlayerTodayScore}
              playerTodayScore={playerTodayScore}
              setCurrentQuestNo={setCurrentQuestNo}
              setFirstLoading={setFirstLoading}
              questWisePlayerScore={questWisePlayerScore}
              setQuestWisePlayerScore={setQuestWisePlayerScore}
            />
          ) : (
            <TopMenuBarFutureTheme
              playMenuSound={playMenuSound}
              isLeaderboardEnabled={isLeaderboardEnabled}
              setIsLeaderboardEnabled={setIsLeaderboardEnabled}
              dontShowTopMenu={dontShowTopMenu}
              preloadedAssets={preloadedAssets}
              currentScreenId={currentScreenId}
              setCurrentScreenId={setCurrentScreenId}
              isSettingOpen={isSettingOpen}
              setIsSettingOpen={setIsSettingOpen}
              setHomeLeaderBoard={setHomeLeaderBoard}
              profileData={profileData}
              gameInfo={gameInfo}
              demoBlocks={demoBlocks}
              data={data}
              type={type}
              setAudioObj={setAudioObj}
              audioObj={audioObj}
              questState={questState}
              EnumType={EnumType}
              setLearnerPlayingDetails={setLearnerPlayingDetails}
              learnerPlayList={learnerPlayList}
              handleMusicVolume={handleMusicVolume}
              homeLeaderBoard={homeLeaderBoard}
              formData={gameInfo?.gameData}
              imageSrc={preloadedAssets.Lead}
              getData={getData}
              setPlayerTodayScore={setPlayerTodayScore}
              playerTodayScore={playerTodayScore}
              setCurrentQuestNo={setCurrentQuestNo}
              setFirstLoading={setFirstLoading}
              questWisePlayerScore={questWisePlayerScore}
              setQuestWisePlayerScore={setQuestWisePlayerScore}
              toggleAudioPlayPause={toggleAudioPlayPause}
              isAudioPaused={isAudioPaused}
            />
          )}
          <Flex
            height="100vh"
            className={currentScreenId === 2 ? '' : 'EntirePreview'}
          >
            {replayIsOpen &&
              (gameInfo?.gameData?.gameTheme === 'false' ? (
                <ReplayScore
                  getSelectedOptions={getSelectedOptions}
                  preloadedAssets={preloadedAssets}
                  setReplayIsOpen={setReplayIsOpen}
                  handleReplayButtonClick={handleReplayButtonClick}
                  replayState={replayState}
                  setCurrentScreenId={setCurrentScreenId}
                  gameInfo={gameInfo}
                  setData={setData}
                  setType={setType}
                  gameInfoquest={gameInfo.questOptions}
                  gameinfodata={gameInfo.gameData.gameShuffle}
                  profileData={profileData}
                  setQuestState={setQuestState}
                  setOptions={setOptions}
                  replayNextHandler={replayNextHandler}
                  data={data}
                  feed={feed}
                  setAudioObj={setAudioObj}
                  isScreenshot={isScreenshot}
                  options={options}
                  setSelectedOption={setSelectedOption}
                  selectedOption={selectedOption}
                  questState={questState}
                  navi={navi}
                  audioCache={audioCacheRef.current}
                  audioReady={audioReady}
                />
              ) : (
                <ReplayScoreFutureTheme
                  getscore={getscore}
                  allQuestScores={allQuestScores}
                  isOpen={replayIsOpen}
                  // onOpenChange={setReplayIsOpen}
                  setReplayIsOpen={setReplayIsOpen}
                  getSelectedOptions={getSelectedOptions}
                  preloadedAssets={preloadedAssets}
                  handleReplayButtonClick={handleReplayButtonClick}
                  replayState={replayState}
                  setCurrentScreenId={setCurrentScreenId}
                  gameInfo={gameInfo}
                  getData={getData}
                  setData={setData}
                  setType={setType}
                  gameInfoquest={gameInfo.questOptions}
                  gameinfodata={gameInfo.gameData.gameShuffle}
                  profileData={profileData}
                  setQuestState={setQuestState}
                  setOptions={setOptions}
                  replayNextHandler={replayNextHandler}
                  data={data}
                  feed={feed}
                  setAudioObj={setAudioObj}
                  isScreenshot={isScreenshot}
                  options={options}
                  setSelectedOption={setSelectedOption}
                  selectedOption={selectedOption}
                  questState={questState}
                  navi={navi}
                  audioCache={audioCacheRef.current}
                  audioReady={audioReady}
                />
              ))}

            <>
              {(currentScreenId === 2 ||
                currentScreenId === 9 ||
                currentScreenId === 14) && (
                <>
                  {/* {gameInfo?.assets?.gasAssetName === 'Medieval office' && ( */}
                  {activeQuestBgName === 'Medieval office' && (
                    <BackgroundGLB
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                      isAnimationPaused={isAnimationPaused}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}
                  {activeQuestBgName === 'Medieval emporium' && (
                    <Emporium
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                      isAnimationPaused={isAnimationPaused}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}
                  {activeQuestBgName === 'Futuristic office' && (
                    <FuturisticOffice
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      mentorNameLanguage={mentorNameLanguage}
                      PlayerNameLanguage={PlayerNameLanguage}
                      isAnimationPaused={isAnimationPaused}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Futuristic City' && (
                    <FurturisticCity
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      mentorNameLanguage={mentorNameLanguage}
                      PlayerNameLanguage={PlayerNameLanguage}
                      scenarioNpc={scenarioNpc}
                      filteredCharacterGLBs={filteredCharacterGLBs}
                      type={type}
                      data={data}
                      demoBlocks={demoBlocks}
                      profile={profile}
                      scenarioChange={scenarioChange}
                      setScenarioNpcs={setScenarioNpcs}
                      scenarioNpcs={scenarioNpcs}
                      scenarioReplay={scenarioReplay}
                      isAnimationPaused={isAnimationPaused}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Futuristic Lab' && (
                    <FuturistiLab
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Future Theme Lab' && (
                    <FutureThemeLab
                      setShowScenarioTransition={setShowScenarioTransition}
                      showScenarioTransition={showScenarioTransition}
                      setNextcharactervoice={setNextcharactervoice}
                      nextcharactervoice={nextcharactervoice}
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      scenarioNpc={scenarioNpc}
                      filteredCharacterGLBs={filteredCharacterGLBs}
                      type={type}
                      data={data}
                      demoBlocks={demoBlocks}
                      profile={profile}
                      scenarioChange={scenarioChange}
                      setScenarioNpcs={setScenarioNpcs}
                      scenarioNpcs={scenarioNpcs}
                      scenarioReplay={scenarioReplay}
                      mentorNameLanguage={mentorNameLanguage}
                      setNextcharacter={setNextcharacter}
                      nextcharacter={nextcharacter}
                      setWalkanimation={setWalkanimation}
                      walkanimation={walkanimation}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Future Theme Lab 1' && (
                    <FutureThemeLab1
                      setShowScenarioTransition={setShowScenarioTransition}
                      showScenarioTransition={showScenarioTransition}
                      setNextcharactervoice={setNextcharactervoice}
                      nextcharactervoice={nextcharactervoice}
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      scenarioNpc={scenarioNpc}
                      filteredCharacterGLBs={filteredCharacterGLBs}
                      type={type}
                      data={data}
                      demoBlocks={demoBlocks}
                      profile={profile}
                      scenarioChange={scenarioChange}
                      setScenarioNpcs={setScenarioNpcs}
                      scenarioNpcs={scenarioNpcs}
                      scenarioReplay={scenarioReplay}
                      mentorNameLanguage={mentorNameLanguage}
                      setNextcharacter={setNextcharacter}
                      nextcharacter={nextcharacter}
                      setWalkanimation={setWalkanimation}
                      walkanimation={walkanimation}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Future Theme Workshop' && (
                    <FutureThemeWorkshop
                      setShowScenarioTransition={setShowScenarioTransition}
                      showScenarioTransition={showScenarioTransition}
                      setNextcharactervoice={setNextcharactervoice}
                      nextcharactervoice={nextcharactervoice}
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      scenarioNpc={scenarioNpc}
                      filteredCharacterGLBs={filteredCharacterGLBs}
                      type={type}
                      data={data}
                      demoBlocks={demoBlocks}
                      profile={profile}
                      scenarioChange={scenarioChange}
                      setScenarioNpcs={setScenarioNpcs}
                      scenarioNpcs={scenarioNpcs}
                      scenarioReplay={scenarioReplay}
                      mentorNameLanguage={mentorNameLanguage}
                      setNextcharacter={setNextcharacter}
                      nextcharacter={nextcharacter}
                      setWalkanimation={setWalkanimation}
                      walkanimation={walkanimation}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Future Theme Workshop 1' && (
                    <FutureThemeWorkShop1
                      setShowScenarioTransition={setShowScenarioTransition}
                      showScenarioTransition={showScenarioTransition}
                      setNextcharactervoice={setNextcharactervoice}
                      nextcharactervoice={nextcharactervoice}
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      scenarioNpc={scenarioNpc}
                      filteredCharacterGLBs={filteredCharacterGLBs}
                      type={type}
                      data={data}
                      demoBlocks={demoBlocks}
                      profile={profile}
                      scenarioChange={scenarioChange}
                      setScenarioNpcs={setScenarioNpcs}
                      scenarioNpcs={scenarioNpcs}
                      scenarioReplay={scenarioReplay}
                      mentorNameLanguage={mentorNameLanguage}
                      setNextcharacter={setNextcharacter}
                      nextcharacter={nextcharacter}
                      setWalkanimation={setWalkanimation}
                      walkanimation={walkanimation}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Medieval castle' && (
                    <Castle
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Magical office' && (
                    <Office
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Magical underground' && (
                    <Underground
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Magical garden' && (
                    <MagicalGarden
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      PlayerNameLanguage={PlayerNameLanguage}
                      isAnimationPaused={isAnimationPaused}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Realistic workplace' && (
                    <RealWorkplace
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Realistic Factory' && (
                    <RealFactory
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}{' '}
                  {activeQuestBgName === 'Realistic office' && (
                    <RealisticOffice
                      preloadedAssets={preloadedAssets}
                      setModalLoaded={setModalLoaded}
                      modalLoaded={modalLoaded}
                      currentScreenId={currentScreenId}
                      SetGlbPlayingDetails={SetGlbPlayingDetails}
                      GlbPlayindDetails={GlbPlayindDetails}
                      setIsZoomComplete={setIsZoomComplete}
                      isZoomComplete={isZoomComplete}
                      glbName={glbName}
                      NonPlayerNameLanguage={NonPlayerNameLanguage}
                      NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                      isAnimationPaused={isAnimationPaused}
                      PlayerNameLanguage={PlayerNameLanguage}
                      mentorNameLanguage={mentorNameLanguage}
                    />
                  )}
                </>
              )}
            </>
            {(() => {
              switch (currentScreenId) {
                case 0:
                  return (
                    <>
                      {
                        <PlayInfo
                          onOpen={onOpen1}
                          onClose={onClose1}
                          isOpen={true}
                          startDemo={startDemo}
                        />
                      }
                    </>
                  );
                case 1:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box
                          w={'100%'}
                          h={'100vh'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          position={'relative'}
                          overflow={'visible'}
                          style={{ perspective: '1000px' }}
                          className="Main-Content"
                        >
                          <Box
                            backgroundImage={preloadedAssets?.introBgImage}
                            w={'100% !important'}
                            h={'100vh'}
                            backgroundRepeat={'no-repeat'}
                            backgroundSize={'cover'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            className="Game-Screen"
                            backgroundColor={'#0d161e'}
                          >
                            <Box className="Images" h={'100vh !important'}>
                              <Welcome
                                intro={audio}
                                currentScreenId={currentScreenId}
                                setCurrentScreenId={setCurrentScreenId}
                                formData={gameInfo?.gameData}
                                imageSrc={preloadedAssets.backgroundImage}
                                screen={preloadedAssets.Screen5}
                                preloadedAssets={preloadedAssets}
                                profileData={profileData}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <WelcomeFutureTheme
                          intro={audio}
                          currentScreenId={currentScreenId}
                          setCurrentScreenId={setCurrentScreenId}
                          formData={gameInfo?.gameData}
                          gameIdingamepreview={gameIdingamepreview}
                          imageSrc={preloadedAssets.backgroundImage}
                          screen={preloadedAssets.Screen5}
                          preloadedAssets={preloadedAssets}
                          profileData={profileData}
                        />
                      )}
                    </>
                  );
                case 2:
                  return (
                    <>
                      {data && type && (
                        <>
                          <Story
                           AssignId={AssignId}
                            gameProgressData={gameProgressData}
                          setGameProgressData={setGameProgressData}
                           setData={setData}
                          setOptions={setOptions}
                            seconds={formatTime(seconds)}
                          BlockSeqNextPreviousNotes={BlockSeqNextPreviousNotes}
                            fetchblockScore={fetchblockScore}
                            setLastInteractionScore={setLastInteractionScore}
                            onScenarioCompleted={(scenarioName, questNo) => {
                            
                              const condition1 =
                                currentReplayInfo &&
                                currentReplayInfo.scenarioName === scenarioName;
                              // const condition2 = questState[questNo] == "replayallowed";
                              const condition2 =
                                questState[questNo] === 'replayallowed';
                              // currentReplayInfo !== null;

                              if (condition1 || condition2) {
                                // Determine the replayType based on which condition is true
                                let finalReplayType;

                                if (condition1) {
                                  // Use the replayType from currentReplayInfo
                                  finalReplayType =
                                    currentReplayInfo.replayType;
                                } else if (
                                  condition2 &&
                                  !OptionalReplayTracked
                                ) {
                                  // For condition2 (questState is replayallowed), ALWAYS use "optionalReplay"
                                  finalReplayType = 'optionalReplay';
                                }

                                if (finalReplayType) {
                                  incrementScenarioReplayCount(
                                    scenarioName,
                                    questNo,
                                    finalReplayType,
                                    setLearnerPlayingDetails,
                                    actionRef,
                                  );
                                }
                                // Reset after increment
                                setCurrentReplayInfo(null);
                                UpdateLearnerData();
                              }
                            }}
                            currentReplayInfo={currentReplayInfo}
                            setShowScenarioLeaderboard={
                              setShowScenarioLeaderboard
                            }
                            showScenarioLeaderboard={showScenarioLeaderboard}
                            isDoorEntry={isDoorEntry}
                            setIsDoorEntry={setIsDoorEntry}
                            toggleAudioPlayPause={toggleAudioPlayPause}
                            WeHaveChooseCompleted={WeHaveChooseCompleted}
                            setWeHaveChooseCompleted={setWeHaveChooseCompleted}
                            isSwipeMiniGameCompleted={isSwipeMiniGameCompleted}
                            setIsSwipeMiniGameCompleted={
                              setIsSwipeMiniGameCompleted
                            }
                            isDragForNowCompleted={isDragForNowCompleted}
                            setIsDragForNowCompleted={setIsDragForNowCompleted}
                            setShowScenarioTransition={
                              setShowScenarioTransition
                            }
                            showScenarioTransition={showScenarioTransition}
                            setNextcharactervoice={setNextcharactervoice}
                            nextcharactervoice={nextcharactervoice}
                            setType={setType}
                            isAudioPaused={isAudioPaused}
                            setBadgethpath={setBadgethpath}
                            setBadgename={setBadgename}
                            badgename={badgename}
                            badgethpath={badgethpath}
                            setActivitydata={setActivitydata}
                            Activitydata={Activitydata}
                            sceneriowiseEarnedScore={sceneriowiseEarnedScore}
                            setscenariowisebestscore1={
                              setscenariowisebestscore1
                            }
                            scenariowisebestscore1={scenariowisebestscore1}
                            setSceneriowiseEarnedScore={
                              setSceneriowiseEarnedScore
                            }
                            sceneriowiseHighestEarnedScore={
                              sceneriowiseHighestEarnedScore
                            }
                            setSceneriowiseHighestEarnedScore={
                              setSceneriowiseHighestEarnedScore
                            }
                            scenarioTotalScore={scenarioTotalScore}
                            setScenarioTotalScore={setScenarioTotalScore}
                            scenarioMinScore={scenarioMinScore}
                            setScenarioMinScore={setScenarioMinScore}
                            scenarioDistinctionScore={scenarioDistinctionScore}
                            setScenarioDistinctionScore={
                              setScenarioDistinctionScore
                            }
                            scenarioAllTimeScore={scenarioAllTimeScore}
                            setScenarioAllTimeScore={setScenarioAllTimeScore}
                            learner_game_play_id={learner_game_play_id}
                            setisScreenshot={setisScreenshot}
                            isScreenshot={isScreenshot}
                            getFeedbackData={getFeedbackData}
                            setFirstLoading={setFirstLoading}
                            profile={profile}
                            setCurrentScreenId={setCurrentScreenId}
                            setCurrentQuestNo={setCurrentQuestNo}
                            setFeedbackCurrentPosition={
                              setFeedbackCurrentPosition
                            }
                            FeedbackcurrentPosition={FeedbackcurrentPosition}
                            NonPlayerNameLanguage={NonPlayerNameLanguage}
                            currentScreenId={currentScreenId}
                            backgroundScreenUrl={
                              preloadedAssets?.backgroundImage
                            }
                            handleScenarioReplayButtonClick={
                              handleScenarioReplayButtonClick
                            }
                            isInteractionButtonDisabled={
                              isInteractionButtonDisabled
                            }
                            setIsInteractionButtonDisabled={
                              setIsInteractionButtonDisabled
                            }
                            handleInteractionBackClick={
                              handleInteractionBackClick
                            }
                            modalLoaded={modalLoaded}
                            selectedPlayer={selectedPlayer}
                            formData={gameInfo?.gameData}
                            data={data}
                            type={type}
                            interactionfeedback={interactionfeedback}
                            handleValidate={handleValidate}
                            resMsg={resMsg}
                            feed={feed}
                            getSelectedOptions={getSelectedOptions}
                            getData={getData}
                            options={options}
                            profileData={profileData}
                            setAudioObj={setAudioObj}
                            setNavTrack={setNavTrack}
                            navTrack={navTrack}
                            gameInfo={gameInfo}
                            preloadedAssets={preloadedAssets}
                            LastModiPrevData={LastModiPrevData}
                            RepeatSelectOption={RepeatSelectOption}
                            RepeatPrevOption={RepeatPrevOption}
                            setScore={setScore}
                            SetAudioOptions={SetAudioOptions}
                            score={score}
                            AudioOptions={AudioOptions}
                            upComingBlockChoosen={upComingBlockChoosen}
                            learnerPlayList={learnerPlayList}
                            option={selectedOption}
                            SetGlbPlayingDetails={SetGlbPlayingDetails}
                            setIsZoomComplete={setIsZoomComplete}
                            isZoomComplete={isZoomComplete}
                            setNonPlayerNameLanguage={setNonPlayerNameLanguage}
                            questState={questState}
                            originalScore={originalScore}
                            setLearnerPlayingDetails={setLearnerPlayingDetails}
                            navi={navi}
                            currentBlock={currentBlock}
                            loadingProgress={loadingProgress}
                            homeLeaderBoard={homeLeaderBoard}
                            setHomeLeaderBoard={setHomeLeaderBoard}
                            setPlayerTodayScore={setPlayerTodayScore}
                            playerTodayScore={playerTodayScore}
                            setNonPlayerNameLanguageId={
                              setNonPlayerNameLanguageId
                            }
                            scenarioNpc={scenarioNpc}
                            NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                            filteredCharacterGLBs={filteredCharacterGLBs}
                            setNextcharacter={setNextcharacter}
                            nextcharacter={nextcharacter}
                            setWalkanimation={setWalkanimation}
                            walkanimation={walkanimation}
                            audioCache={audioCacheRef.current}
                            audioReady={audioReady}
                            setOptionalReplayTracked={setOptionalReplayTracked}
                          />
                        </>
                      )}
                    </>
                  );
                case 3:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box
                          w={'100%'}
                          h={'100vh'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          position={'relative'}
                          overflow={'visible'}
                          style={{ perspective: '1000px' }}
                          className="Main-Content"
                        >
                          <Box className="Game-Screen">
                            <Box className="Images">
                              <Reflection
                                formData={gameInfo?.gameData}
                                imageSrc={preloadedAssets.RefBg}
                                reflectionQuestions={
                                  gameInfo?.reflectionQuestions
                                }
                                gameInfo={gameInfo}
                                setCurrentScreenId={setCurrentScreenId}
                                preloadedAssets={preloadedAssets}
                                FeedbackcurrentPosition={
                                  FeedbackcurrentPosition
                                }
                                setFeedbackCurrentPosition={
                                  setFeedbackCurrentPosition
                                }
                                interactionBlockArray={interactionBlockArray}
                                profileData={profileData}
                                getFeedbackData={getFeedbackData}
                                feedbackList={feedbackList}
                                setInterActionBlockArray={
                                  setInterActionBlockArray
                                }
                                setFeedbackNavigateNext={
                                  setFeedbackNavigateNext
                                }
                                setCurrentQuestNo={setCurrentQuestNo}
                                setFirstLoading={setFirstLoading}
                                learnerPlayList={learnerPlayList}
                                setLearnerPlayingDetails={
                                  setLearnerPlayingDetails
                                }
                              />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <ReflectionFutureTheme
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets.RefBg}
                          reflectionQuestions={gameInfo?.reflectionQuestions}
                          gameInfo={gameInfo}
                          setCurrentScreenId={setCurrentScreenId}
                          preloadedAssets={preloadedAssets}
                          FeedbackcurrentPosition={FeedbackcurrentPosition}
                          setFeedbackCurrentPosition={
                            setFeedbackCurrentPosition
                          }
                          interactionBlockArray={interactionBlockArray}
                          profileData={profileData}
                          getFeedbackData={getFeedbackData}
                          feedbackList={feedbackList}
                          setInterActionBlockArray={setInterActionBlockArray}
                          setFeedbackNavigateNext={setFeedbackNavigateNext}
                          setCurrentQuestNo={setCurrentQuestNo}
                          setFirstLoading={setFirstLoading}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                        />
                      )}
                    </>
                  );
                case 4:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box
                          w={'100%'}
                          h={'100vh'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          position={'relative'}
                          overflow={'visible'}
                          style={{ perspective: '1000px' }}
                          className="Main-Content"
                        >
                          <Box
                            backgroundImage={preloadedAssets?.introBgImage}
                            backgroundColor={'#0d161e'}
                            w={'100% !important'}
                            h={'100vh'}
                            backgroundRepeat={'no-repeat'}
                            backgroundSize={'cover'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            className="Game-Screen"
                          >
                            <Box className="Images" zIndex={99}>
                              <LeaderBoard
                                homeLeaderBoard={homeLeaderBoard}
                                setHomeLeaderBoard={setHomeLeaderBoard}
                                setCurrentScreenId={setCurrentScreenId}
                                formData={gameInfo?.gameData}
                                imageSrc={preloadedAssets.Lead}
                                getData={getData}
                                data={data}
                                gameInfo={gameInfo}
                                preloadedAssets={preloadedAssets}
                                setPlayerTodayScore={setPlayerTodayScore}
                                playerTodayScore={playerTodayScore}
                                setCurrentQuestNo={setCurrentQuestNo}
                                setFirstLoading={setFirstLoading}
                                learnerPlayList={learnerPlayList}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <LeaderBoardFutureTheme
                          playMenuSound={playMenuSound}
                          homeLeaderBoard={homeLeaderBoard}
                          setHomeLeaderBoard={setHomeLeaderBoard}
                          setCurrentScreenId={setCurrentScreenId}
                          currentScreenId={currentScreenId}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets.Lead}
                          getData={getData}
                          data={data}
                          gameInfo={gameInfo}
                          preloadedAssets={preloadedAssets}
                          setPlayerTodayScore={setPlayerTodayScore}
                          playerTodayScore={playerTodayScore}
                          setCurrentQuestNo={setCurrentQuestNo}
                          setFirstLoading={setFirstLoading}
                          learnerPlayList={learnerPlayList}
                        />
                      )}
                    </>
                  );
                case 5:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box
                          w={'100%'}
                          h={'100vh'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          position={'relative'}
                          overflow={'visible'}
                          style={{ perspective: '1000px' }}
                          className="Main-Content"
                        >
                          <Box
                            backgroundImage={preloadedAssets?.introBgImage}
                            backgroundColor={'#0d161e'}
                            w={'100% !important'}
                            h={'100vh'}
                            backgroundRepeat={'no-repeat'}
                            backgroundSize={'cover'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            className="Game-Screen"
                          >
                            <Box className="Images">
                              <ThankYou
                                setCurrentScreenId={setCurrentScreenId}
                                formData={gameInfo?.gameData}
                                imageSrc={preloadedAssets.ThankYou}
                                preloadedAssets={preloadedAssets}
                                gameInfo={gameInfo}
                                FeedbackcurrentPosition={
                                  FeedbackcurrentPosition
                                }
                                setFeedbackCurrentPosition={
                                  setFeedbackCurrentPosition
                                }
                                interactionBlockArray={interactionBlockArray}
                                profileData={profileData}
                                getFeedbackData={getFeedbackData}
                                feedbackList={feedbackList}
                                setInterActionBlockArray={
                                  setInterActionBlockArray
                                }
                                setFeedbackNavigateNext={
                                  setFeedbackNavigateNext
                                }
                                setCurrentQuestNo={setCurrentQuestNo}
                                setFirstLoading={setFirstLoading}
                                learnerPlayList={learnerPlayList}
                                setLearnerPlayingDetails={
                                  setLearnerPlayingDetails
                                }
                                AssignId={AssignId}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <ThankyouFutureTheme
                          playMenuSound={playMenuSound}
                          setCurrentScreenId={setCurrentScreenId}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets.ThankYou}
                          preloadedAssets={preloadedAssets}
                          gameInfo={gameInfo}
                          FeedbackcurrentPosition={FeedbackcurrentPosition}
                          setFeedbackCurrentPosition={
                            setFeedbackCurrentPosition
                          }
                          interactionBlockArray={interactionBlockArray}
                          profileData={profileData}
                          getFeedbackData={getFeedbackData}
                          feedbackList={feedbackList}
                          setInterActionBlockArray={setInterActionBlockArray}
                          setFeedbackNavigateNext={setFeedbackNavigateNext}
                          setCurrentQuestNo={setCurrentQuestNo}
                          setFirstLoading={setFirstLoading}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          AssignId={AssignId}
                        />
                      )}
                    </>
                  );
                case 6:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box
                          w={'100%'}
                          h={'100vh'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          position={'relative'}
                          overflow={'visible'}
                          style={{ perspective: '1000px' }}
                          className="Main-Content"
                        >
                          <Box
                            backgroundImage={preloadedAssets?.introBgImage}
                            backgroundColor={'#0d161e'}
                            w={'100% !important'}
                            h={'100vh'}
                            backgroundRepeat={'no-repeat'}
                            backgroundSize={'cover'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            className="Game-Screen"
                          >
                            <Box className="Images">
                              <Completion
                                getData={getData}
                                questState={questState}
                                setQuestState={setQuestState}
                                data={data}
                                setFeedbackNavigateNext={
                                  setFeedbackNavigateNext
                                }
                                getFeedbackData={getFeedbackData}
                                gameInfo={gameInfo}
                                currentScreenId={currentScreenId}
                                setCurrentScreenId={setCurrentScreenId}
                                currentQuestNo={currentQuestNo}
                                preloadedAssets={preloadedAssets}
                                setType={setType}
                                setData={setData}
                                type={type}
                                setOptions={setOptions}
                                profileData={profileData}
                                feedbackList={feedbackList}
                                setFeedbackList={setFeedbackList}
                                learnerPlayList={learnerPlayList}
                                setLearnerPlayingDetails={
                                  setLearnerPlayingDetails
                                }
                                setprevBlock={setprevBlock}
                                prevBlock={prevBlock}
                                demoBlocks={demoBlocks}
                                checkCompletionBadge={checkCompletionBadge}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <QuestCompletionFutureTheme
                          playMenuSound={playMenuSound}
                          WeHaveChooseCompleted={WeHaveChooseCompleted}
                          setWeHaveChooseCompleted={setWeHaveChooseCompleted}
                          isSwipeMiniGameCompleted={isSwipeMiniGameCompleted}
                          setIsSwipeMiniGameCompleted={
                            setIsSwipeMiniGameCompleted
                          }
                          isDragForNowCompleted={isDragForNowCompleted}
                          setIsDragForNowCompleted={setIsDragForNowCompleted}
                          getscore={getscore}
                          setIsCompletedVideoMap={setIsCompletedVideoMap}
                          iscompletedVideoMap={iscompletedVideoMap}
                          completedVideoRef={completedVideoRef}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets.Screen4}
                          getData={getData}
                          questState={questState}
                          setQuestState={setQuestState}
                          data={data}
                          setFeedbackNavigateNext={setFeedbackNavigateNext}
                          getFeedbackData={getFeedbackData}
                          gameInfo={gameInfo}
                          currentScreenId={currentScreenId}
                          setCurrentScreenId={setCurrentScreenId}
                          currentQuestNo={currentQuestNo}
                          preloadedAssets={preloadedAssets}
                          setType={setType}
                          setData={setData}
                          type={type}
                          setOptions={setOptions}
                          profileData={profileData}
                          feedbackList={feedbackList}
                          setFeedbackList={setFeedbackList}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          setprevBlock={setprevBlock}
                          prevBlock={prevBlock}
                          demoBlocks={demoBlocks}
                          checkCompletionBadge={checkCompletionBadge}
                        />
                      )}
                    </>
                  );
                case 7:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Box
                          w={'100%'}
                          h={'100vh'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          position={'relative'}
                          overflow={'visible'}
                          style={{ perspective: '1000px' }}
                          className="Main-Content"
                        >
                          <Box
                            backgroundImage={preloadedAssets?.introBgImage}
                            backgroundColor={'#0d161e'}
                            w={'100% !important'}
                            h={'100vh'}
                            backgroundRepeat={'no-repeat'}
                            backgroundSize={'cover'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            className="Game-Screen"
                          >
                            <Box className="Images">
                              <Takeway
                                formData={gameInfo?.gameData}
                                imageSrc={preloadedAssets.Screen4}
                                getData={getData}
                                data={data}
                                preloadedAssets={preloadedAssets}
                                gameInfo={gameInfo}
                                setCurrentScreenId={setCurrentScreenId}
                                FeedbackcurrentPosition={
                                  FeedbackcurrentPosition
                                }
                                setFeedbackCurrentPosition={
                                  setFeedbackCurrentPosition
                                }
                                interactionBlockArray={interactionBlockArray}
                                profileData={profileData}
                                getFeedbackData={getFeedbackData}
                                feedbackList={feedbackList}
                                setInterActionBlockArray={
                                  setInterActionBlockArray
                                }
                                setFeedbackNavigateNext={
                                  setFeedbackNavigateNext
                                }
                                setCurrentQuestNo={setCurrentQuestNo}
                                setFirstLoading={setFirstLoading}
                              />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <TakeawayFutureTheme
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets.Screen4}
                          getData={getData}
                          data={data}
                          preloadedAssets={preloadedAssets}
                          gameInfo={gameInfo}
                          setCurrentScreenId={setCurrentScreenId}
                          FeedbackcurrentPosition={FeedbackcurrentPosition}
                          setFeedbackCurrentPosition={
                            setFeedbackCurrentPosition
                          }
                          interactionBlockArray={interactionBlockArray}
                          profileData={profileData}
                          getFeedbackData={getFeedbackData}
                          feedbackList={feedbackList}
                          setInterActionBlockArray={setInterActionBlockArray}
                          setFeedbackNavigateNext={setFeedbackNavigateNext}
                          setCurrentQuestNo={setCurrentQuestNo}
                          setFirstLoading={setFirstLoading}
                        />
                      )}
                    </>
                  );
                case 8:
                  return (
                    <>
                      <Box
                        w={'100%'}
                        h={'100vh'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        position={'relative'}
                        overflow={'visible'}
                        style={{ perspective: '1000px' }}
                        className="Main-Content"
                      >
                        <Box
                          backgroundImage={preloadedAssets.backgroundImage}
                          w={'100% !important'}
                          h={'100vh'}
                          backgroundRepeat={'no-repeat'}
                          backgroundSize={'cover'}
                          alignItems={'center'}
                          justifyContent={'center'}
                          className="Game-Screen"
                        >
                          <Box className="Images">
                            <ReplayGame
                              replayGame={replayGame}
                              replayNextHandler={replayNextHandler}
                              type={type}
                              gameInfo={gameInfo}
                              setType={setType}
                              setData={setData}
                              isOptionalReplay={isOptionalReplay}
                              setisOptionalReplay={setisOptionalReplay}
                              setisReplay={setisReplay}
                              isReplay={isReplay}
                              formData={gameInfo?.gameData}
                              imageSrc={preloadedAssets.Replay}
                              getData={getData}
                              data={data}
                              preloadedAssets={preloadedAssets}
                              profilescore={profilescore}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </>
                  );
                case 10:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <GameIntroScreen
                          preloadedAssets={preloadedAssets}
                          setCurrentScreenId={setCurrentScreenId}
                          currentScreenId={currentScreenId}
                          gameInfo={gameInfo.gameData}
                          hasMulitLanguages={hasMulitLanguages}
                          setReplayState={setReplayState}
                          setReplayIsOpen={setReplayIsOpen}
                          setQuestState={setQuestState}
                          gameLanguages={gameLanguages}
                          isInitialLoadScreenWelcome={
                            isInitialLoadScreenWelcome
                          }
                          setIsInitialLoadScreenWelcome={
                            setIsInitialLoadScreenWelcome
                          }
                          profileData={profileData}
                          setProfileData={setProfileData}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          setAssignId={setAssignId}
                          AssignId={AssignId}
                          UpdateLearnerData={UpdateLearnerData}
                          setFeedbackList={setFeedbackList}
                        />
                      ) : (
                        <GameIntroScreenFutureTheme
                          // floatingHubUrl={floatingHubUrl}
                          // setFloatingHubUrl={setFloatingHubUrl}
                          gameProgressData={gameProgressData}
                          showFloatingHub={showFloatingHub}
                          //  setIsTransitioning={setIsTransitioning}
                          //       //by kaviya
                          //       isTransitioning={isTransitioning}
                          // isQuestVideoReady={isQuestVideoReady}
                          //  setIsFloatingReady={setIsFloatingReady}
                          //  isFloatingReady={isFloatingReady}
                          // setIsQuestVideoReady={setIsQuestVideoReady}
                          setShowFloatingHub={setShowFloatingHub}
                          audioObj={audioObj}
                          setAudioObj={setAudioObj}
                          preloadedAssets={preloadedAssets}
                          setCurrentScreenId={setCurrentScreenId}
                          currentScreenId={currentScreenId}
                          gameInfo={gameInfo.gameData}
                          hasMulitLanguages={hasMulitLanguages}
                          setReplayState={setReplayState}
                          setReplayIsOpen={setReplayIsOpen}
                          setQuestState={setQuestState}
                          gameLanguages={gameLanguages}
                          isInitialLoadScreenWelcome={
                            isInitialLoadScreenWelcome
                          }
                          setIsInitialLoadScreenWelcome={
                            setIsInitialLoadScreenWelcome
                          }
                          profileData={profileData}
                          setProfileData={setProfileData}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          setAssignId={setAssignId}
                          AssignId={AssignId}
                          UpdateLearnerData={UpdateLearnerData}
                          setFeedbackList={setFeedbackList}
                        />
                      )}
                    </>
                  );
                case 12:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <Characterspage
                        
                          profileData={profileData}
                          setProfileData={setProfileData}
                          currentScreenId={currentScreenId}
                          setSelectedPlayer={setSelectedPlayer}
                          players={gameInfo?.gamePlayers}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets?.introBgImage}
                          setCurrentScreenId={setCurrentScreenId}
                          demoBlocks={demoBlocks}
                          preloadedAssets={preloadedAssets}
                          ModelPlayer={ModelPlayer}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          selectedBackground={selectedBackground}
                          backgroundtheme={backgroundtheme}
                        />
                      ) : (
                        <CharacterSelectionFutureTheme
                          profileData={profileData}
                          setProfileData={setProfileData}
                          currentScreenId={currentScreenId}
                          setSelectedPlayer={setSelectedPlayer}
                          players={gameInfo?.gamePlayers}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets?.introBgImage}
                          setCurrentScreenId={setCurrentScreenId}
                          demoBlocks={demoBlocks}
                          preloadedAssets={preloadedAssets}
                          ModelPlayer={ModelPlayer}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          selectedBackground={selectedBackground}
                          backgroundtheme={backgroundtheme}
                          audioObj={audioObj}
                          setAudioObj={setAudioObj}
                        />
                      )}
                    </>
                  );

                case 13:
                  return (
                    <>
                      <ChapterPage
                          overallqueststate={overallqueststate}
                        gameProgressData={gameProgressData}
                      setGameProgressData={setGameProgressData}
                        fetchchapterQuestScore={fetchchapterQuestScore}
                        setGameInfo={setGameInfo}
                        setIsDoorEntry={setIsDoorEntry}
                        isAudioPaused={isAudioPaused}
                        toggleAudioPlayPause={toggleAudioPlayPause}
                        questWiseMaxScore={questWiseMaxScore}
                        questTotalScore={questTotalScore}
                        audioObj={audioObj}
                        setAudioObj={setAudioObj}
                        completedVideoRef={completedVideoRef}
                        handleReplayButtonClick={handleReplayButtonClick}
                        setCurrentQuestNo={setCurrentQuestNo}
                        questState={questState}
                        setQuestState={setQuestState}
                        backgroundImg={preloadedAssets.backgroundImage}
                        setCurrentScreenId={setCurrentScreenId}
                        setData={setData}
                        setType={setType}
                        setOptions={setOptions}
                        setFeedbackList={setFeedbackList}
                        preloadedAssets={preloadedAssets}
                        currentScreenId={currentScreenId}
                        profileData={profileData}
                        gameInfo={gameInfo}
                        learnerPlayList={learnerPlayList}
                        setLearnerPlayingDetails={setLearnerPlayingDetails}
                        setAssignId={setAssignId}
                        AssignId={AssignId}
                        setActivitydata={setActivitydata}
                        Activitydata={Activitydata}
                        setprevBlock={setprevBlock}
                        prevBlock={prevBlock}
                        getData={getData}
                        setNavi={setNavi}
                        setFeed={setFeed}
                        setRepeatSelectOption={setRepeatSelectOption}
                        RepeatPrevOption={RepeatPrevOption}
                        setRepeatPrevOption={setRepeatPrevOption}
                        setReplayIsOpen={setReplayIsOpen}
                        setReplayState={setReplayState}
                        setIsZoomComplete={setIsZoomComplete}
                        isZoomComplete={isZoomComplete}
                        scoreChapter={scoreChapter}
                        setScoreChapter={setScoreChapter}
                        questWisePlayerScore={questWisePlayerScore}
                        setQuestWisePlayerScore={setQuestWisePlayerScore}
                        checkCompletionBadge={checkCompletionBadge}
                        NonPlayerNameLanguage={NonPlayerNameLanguage}
                        NonPlayerNameLanguageId={NonPlayerNameLanguageId}
                        setHubDialogAudio={setHubDialogAudio}
                        hubDialogAudio={hubDialogAudio}
                        PlayerNameLanguage={PlayerNameLanguage}
                        SetGlbPlayingDetails={SetGlbPlayingDetails} // Add this
                        GlbPlayindDetails={GlbPlayindDetails}
                        isAnimationPaused={isAnimationPaused}
                        mentorNameLanguage={mentorNameLanguage}
                        reportFetchData={reportFetchData}
                        isSettingOpen={isSettingOpen}
                        setIsSettingOpen={setIsSettingOpen}
                      />
                    </>
                  );
                case 14:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <FeedBackScreen
                          backgroundScreenUrl={preloadedAssets?.backgroundImage}
                          isScreenshot={isScreenshot}
                          FeedbackremainingSentences={
                            FeedbackremainingSentences
                          }
                          setisScreenshot={setisScreenshot}
                          options={options}
                          FeedBackselectedoptionData={
                            FeedBackselectedoptionData
                          }
                          FeedBackoptionData={FeedBackoptionData}
                          getFeedbackData={getFeedbackData}
                          data={data}
                          currentScreenId={currentScreenId}
                          getData={getData}
                          profile={profile}
                          preloadedAssets={preloadedAssets}
                          profileData={profileData}
                          interactionBlockArray={interactionBlockArray}
                          FeedbackcurrentPosition={FeedbackcurrentPosition}
                          setFeedbackCurrentPosition={
                            setFeedbackCurrentPosition
                          }
                          setCurrentScreenId={setCurrentScreenId}
                          gameInfo={gameInfo}
                          setAudioObj={setAudioObj}
                          firstLoading={firstLoading}
                          setFirstLoading={setFirstLoading}
                          InterActionScore={InterActionScore}
                          setCurrentQuestNo={setCurrentQuestNo}
                          NonPlayerNameLanguage={NonPlayerNameLanguage}
                          audioCache={audioCacheRef.current}
                          audioReady={audioReady}
                        />
                      ) : (
                        <CompletionFeedBackScreenFutureTheme
                        AssignId={AssignId}
                          seconds={formatTime(seconds)}
                          scenariowisebestscore1={scenariowisebestscore1}
                          sceneriowiseHighestEarnedScore={
                            sceneriowiseHighestEarnedScore
                          }
                          Activitydata={Activitydata}
                          audioObj={audioObj}
                          scenarioMinScore={scenarioMinScore}
                          setScenarioMinScore={setScenarioMinScore}
                          scenarioDistinctionScore={scenarioDistinctionScore}
                          setScenarioDistinctionScore={
                            setScenarioDistinctionScore
                          }
                          sceneriowiseEarnedScore={sceneriowiseEarnedScore}
                          scenarioTotalScore={scenarioTotalScore}
                          scenarioAllTimeScore={scenarioAllTimeScore}
                          handleScenarioReplayButtonClick={
                            handleScenarioReplayButtonClick
                          }
                          setReplayIsOpen={setReplayIsOpen}
                          handleReplayButtonClick={handleReplayButtonClick}
                          replayNextHandler={replayNextHandler}
                          getSelectedOptions={getSelectedOptions}
                          backgroundScreenUrl={preloadedAssets?.backgroundImage}
                          isScreenshot={isScreenshot}
                          FeedbackremainingSentences={
                            FeedbackremainingSentences
                          }
                          setisScreenshot={setisScreenshot}
                          options={options}
                          setIsDoorEntry={setIsDoorEntry}
                          FeedBackselectedoptionData={
                            FeedBackselectedoptionData
                          }
                          FeedBackoptionData={FeedBackoptionData}
                          getFeedbackData={getFeedbackData}
                          data={data}
                          currentScreenId={currentScreenId}
                          getData={getData}
                          profile={profile}
                          preloadedAssets={preloadedAssets}
                          profileData={profileData}
                          interactionBlockArray={interactionBlockArray}
                          FeedbackcurrentPosition={FeedbackcurrentPosition}
                          setFeedbackCurrentPosition={
                            setFeedbackCurrentPosition
                          }
                          setCurrentScreenId={setCurrentScreenId}
                          gameInfo={gameInfo}
                          setAudioObj={setAudioObj}
                          firstLoading={firstLoading}
                          setFirstLoading={setFirstLoading}
                          InterActionScore={InterActionScore}
                          setCurrentQuestNo={setCurrentQuestNo}
                          NonPlayerNameLanguage={NonPlayerNameLanguage}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          prevBlock={prevBlock}
                          setprevBlock={setprevBlock}
                          demoBlocks={demoBlocks}
                          setProfile={setProfile}
                          questState={questState}
                          setOptions={setOptions}
                          setType={setType}
                          setData={setData}
                          audioCache={audioCacheRef.current}
                          audioReady={audioReady}
                        />
                      )}
                    </>
                  );
                case 15:
                  return (
                    <>
                      <SkillSet
                        data={data}
                        preloadedAssets={preloadedAssets}
                        setCurrentScreenId={setCurrentScreenId}
                      />
                    </>
                  );
                  break;
                case 16:
                  return (
                    <>
                      <StartAssesmnetPage
                        setCurrentScreenId={setCurrentScreenId}
                      />
                    </>
                  );
                  break;
                case 17:
                  return (
                    <>
                      <AssessmentFutureTheme
                        // setLearnerPlayingDetails={setLearnerPlayingDetails}
                        // onAssessmentComplete={handleAssessmentComplete}
                        setCurrentScreenId={setCurrentScreenId}
                        learnerPlayList={learnerPlayList}
                        setLearnerPlayingDetails={setLearnerPlayingDetails}
                        reportFetchData={reportFetchData}
                        onAssessmentComplete={(metrics: any) => {
                          handleAssessmentComplete(metrics);
                        }}
                      />
                    </>
                  );
                  break;
                case 18:
                  return (
                    <>
                      <CertificationHub
                        learnerPlayList={learnerPlayList}
                        currentScreenId={currentScreenId}
                        setCurrentScreenId={setCurrentScreenId}
                      />
                    </>
                  );
                  break;
                case 19:
                  return (
                    <>
                      <LearnerMainFile
                        reportData={reportData}
                        setReportData={setReportData}
                        loading={loading}
                        setLoading={setLoading}
                        error={error}
                        setError={setError}
                        setLearnerPlayingDetails={setLearnerPlayingDetails}
                        learnerPlayList={learnerPlayList}
                        setCurrentScreenId={setCurrentScreenId}
                        currentScreenId={currentScreenId}
                        setHtmlString={setHtmlString}
                        htmlString={htmlString}
                      />
                    </>
                  );
                  break;
                case 20:
                  return (
                    <>
                      {gameInfo?.gameData?.gameTheme === 'false' ? (
                        <MentorCharacterspage
                          profileData={profileData}
                          setProfileData={setProfileData}
                          currentScreenId={currentScreenId}
                          setSelectedPlayer={setSelectedPlayer}
                          players={gameInfo?.gamePlayers}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets?.introBgImage}
                          setCurrentScreenId={setCurrentScreenId}
                          demoBlocks={demoBlocks}
                          preloadedAssets={preloadedAssets}
                          ModelPlayer={ModelPlayer}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          selectedBackground={selectedBackground}
                          backgroundtheme={backgroundtheme}
                        />
                      ) : (
                        <MentorCharacterSelectionFutureTheme
                          profileData={profileData}
                          setProfileData={setProfileData}
                          currentScreenId={currentScreenId}
                          setSelectedPlayer={setSelectedPlayer}
                          players={gameInfo?.gamePlayers}
                          formData={gameInfo?.gameData}
                          imageSrc={preloadedAssets?.introBgImage}
                          setCurrentScreenId={setCurrentScreenId}
                          demoBlocks={demoBlocks}
                          preloadedAssets={preloadedAssets}
                          ModelPlayer={ModelPlayer}
                          learnerPlayList={learnerPlayList}
                          setLearnerPlayingDetails={setLearnerPlayingDetails}
                          selectedBackground={selectedBackground}
                          backgroundtheme={backgroundtheme}
                          audioObj={audioObj}
                          setAudioObj={setAudioObj}
                        />
                      )}
                    </>
                  );

                case 21:
                  return (
                    <>
                      {/* {allQuestScores?.overallQuestState === "replayallowed" && ( */}

                      <OverallQuestCompletionFutureTheme
                        allQuestScores={allQuestScores}
                        setIsCompletedVideoMap={setIsCompletedVideoMap}
                        iscompletedVideoMap={iscompletedVideoMap}
                        completedVideoRef={completedVideoRef}
                        formData={gameInfo?.gameData}
                        imageSrc={preloadedAssets.Screen4}
                        getData={getData}
                        questState={questState}
                        setQuestState={setQuestState}
                        data={data}
                        setFeedbackNavigateNext={setFeedbackNavigateNext}
                        getFeedbackData={getFeedbackData}
                        gameInfo={gameInfo}
                        currentScreenId={currentScreenId}
                        setCurrentScreenId={setCurrentScreenId}
                        currentQuestNo={currentQuestNo}
                        preloadedAssets={preloadedAssets}
                        setType={setType}
                        setData={setData}
                        type={type}
                        setOptions={setOptions}
                        profileData={profileData}
                        feedbackList={feedbackList}
                        setFeedbackList={setFeedbackList}
                        learnerPlayList={learnerPlayList}
                        setLearnerPlayingDetails={setLearnerPlayingDetails}
                        setprevBlock={setprevBlock}
                        prevBlock={prevBlock}
                        demoBlocks={demoBlocks}
                        checkCompletionBadge={checkCompletionBadge}
                        handleQuestScore={handleQuestScore}
                      />

                      {/* )} */}
                    </>
                  );
                  break;

                case 22:
                  return (
                    <>
                      <FinalCertificate
                        currentScreenId={currentScreenId}
                        setCurrentScreenId={setCurrentScreenId}
                        setLearnerPlayingDetails={setLearnerPlayingDetails}
                        learnerPlayList={learnerPlayList}
                        gameInfo={gameInfo}
                      />
                    </>
                  );
                  break;

                default:
                  console.warn(
                    'game details of the data',
                    gameInfo?.gameData,
                    currentScreenId,
                  );
                  return <h1>Loading Screen .... Default case </h1>;
              }
            })()}
          </Flex>

          {audioObj.type === EnumType.BGM && (
            <audio
              ref={backgroundBgmRef}
              loop={audioObj.loop}
              style={{ display: 'block' }}
            >
              <source src={audioObj.url} type="audio/mpeg" />
              Your browser does not support the audio tag.
            </audio>
          )}
          {audioObj.type === EnumType.VOICE && (
            <audio
              ref={voiceRef}
              key={audioObj?.key || audioObj.url}
              style={{ display: 'block' }}
            >
              <source src={audioObj.url} type="audio/mpeg" />
              Your browser does not support the audio tag.
            </audio>
          )}

           {/* {isAssignmentError && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                backdropFilter: 'blur(8px)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '30px',
                  borderRadius: '10px',
                  maxWidth: '400px',
                  width: '90%',
                  textAlign: 'center',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                }}
              >
                <h3 style={{ marginBottom: '20px', color: '#333' }}>
                  Game Assignment Error
                </h3>
                <p style={{ marginBottom: '25px', color: '#666' }}>
                  This game was Not assigned for this learner
                </p>
                <button
                  onClick={handleAssignmentErrorClose}
                  style={{
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '10px 30px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '16px',
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          )} */}




{isAssignmentError && (
  <Box
    position="fixed"
    top="0"
    left="0"
    right="0"
    bottom="0"
    zIndex={999999}
    bg="rgba(0,0,0,0.6)"
    display="flex"
    justifyContent="center"
    alignItems="center"
    sx={{
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
    }}
  >
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0.8, opacity: 0 }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 20,
      }}
      style={{
        width: "572px",
        maxWidth: "90%",
      }}
    >
      <Box
        borderRadius="24px"
        p={10}
        position="relative"
        overflow="hidden"
        bg="rgba(20,20,20,0.75)"
        border={`1px solid ${primaryColor}33`}
        boxShadow={`0px 0px 30px rgba(${hexToRgb(primaryColor)},0.35)`}
      >
        {/* Glow */}
        <Box
          position="absolute"
          top="-120px"
          right="-100px"
          w="320px"
          h="320px"
          borderRadius="50%"
          bg={primaryColor}
          opacity={0.15}
          filter="blur(100px)"
        />

        {/* Title */}
        <Text
          color="white"
          fontSize="30px"
          fontWeight="700"
          textAlign="center"
          mb={6}
          position="relative"
        >
          Game Unassigned
        </Text>

        {/* Message */}
        <Text
          color="white"
          fontSize="18px"
          textAlign="center"
          mb={10}
          position="relative"
        >
          This game is no longer assigned. Your current session will now close.
        </Text>

        {/* Button */}
        <Box display="flex" justifyContent="center">
          <Button
            onClick={handleAssignmentErrorClose}
            color="white"
            borderRadius="40px"
            minW="170px"
            h="56px"
            bg={`linear-gradient(100deg, rgba(${hexToRgb(
              primaryColor
            )}) -27%, rgba(0,0,0,0.8) 128%)`}
            border={`1px solid rgba(${hexToRgb(primaryColor)},0.5)`}
            _hover={{
              transform: "scale(1.05)",
            }}
          >
            OK
          </Button>
        </Box>
      </Box>
    </motion.div>
  </Box>
)}





        </motion.div>
      ) : (
        ''
      )}
    </ProfileContext.Provider>
  );
};

export default EntirePreview;
